'use strict';

angular.module('viAdminUi', [
	'ngAnimate',
	'ngCookies',
	'ngTouch',
	'ngSanitize',
	'restangular',
	'ui.router',
	'ngMaterial',
	'ngMessages',
	'viAdminUi.services.auth',
	'viAdminUi.services.main',
	'viAdminUi.services.activation',
	'angulartics',
	'angulartics.google.analytics',
	'underscore',
	"angular-vin",
	'myApp.config',
    'mgo-angular-wizard',
    'pascalprecht.translate'])
.config(function ($stateProvider, $urlRouterProvider, $mdThemingProvider, $translateProvider) {
	var supportedLanguages = ['en', 'fr', 'nl', 'pl', 'it', 'de', 'pt-br', 'es'];
	var defaultLang = 'en';
	$stateProvider
		.state('home', {
			url: '/',
			templateUrl: 'app/main/main.html',
			controller: 'MainCtrl',
			authenticate: true,
			resolve: {
				translateReady: ['$translate', function($translate) {
					return $translate.onReady();
				}]
			}
		})
		.state("login", {
			url: "/login",
			templateUrl: "app/auth/auth.html",
			controller: "AuthCtrl",
			authenticate: false,
			resolve: {
				translateReady: ['$translate', function($translate) {
					return $translate.onReady();
				}]
			}
		})
		.state("activation", {
			url: "/activation",
			templateUrl: "app/activation/activation.html",
			controller: "ActivationCtrl",
			authenticate: true,
			resolve: {
				translateReady: ['$translate', function($translate) {
					return $translate.onReady();
				}]
			}
		});
		$urlRouterProvider.otherwise('/login');

		$mdThemingProvider.theme('default')
	    .primaryPalette('blue')
	    .accentPalette('orange');

	    $mdThemingProvider.theme('altTheme')
        .primaryPalette('grey');
        
        $translateProvider.useStaticFilesLoader({
            prefix: 'i18n/',
            suffix: '.json'
		});
		var browserLang = navigator.language.toLowerCase();
		var preferredLang = supportedLanguages.includes(browserLang) ? browserLang : defaultLang;
		preferredLang = window.localStorage.getItem($translateProvider.storageKey()) || preferredLang;
		$translateProvider.preferredLanguage(preferredLang);
		$translateProvider.useLocalStorage();
})
.config(['$compileProvider', function ($compileProvider) {
	$compileProvider.debugInfoEnabled(true);
}])
.run(function ($rootScope, $state, authFactory, $http, $mdToast, apiUrl, $mdDialog, $translate) {
	$rootScope.apiUrl = apiUrl;
	$rootScope.localDvrUrl = null;

	//TODO
	//remove this when injection of ng-material start working after ng-route is called.
	$rootScope.$mdDialog = $mdDialog;

	authFactory.refreshUserFromLocalStorage();

	//authentication block
	$rootScope.$on("$stateChangeStart", function(event, toState, toParams, fromState, fromParams){
		if (toState.authenticate && ! authFactory.isAuthenticated()) {
		 	$state.transitionTo("login");
		 	event.preventDefault();
		}
	});

	$rootScope.isNodeWebkit = function () {
	    var isNode = (typeof process !== "undefined" && typeof require !== "undefined");
		var isNodeWebkit = false;

		if(isNode) {
			try {
				isNodeWebkit = (typeof require('nw.gui') !== "undefined");
			} catch(e) {
				isNodeWebkit = false;
			}
	    }
		return isNodeWebkit;
	};

	$rootScope.showSimpleToast = function (text, status, delay) {
		var simple = $mdToast.simple();
		var template = angular.element(simple._options.template);
		if (status) {
			template.addClass('md-toast-success');
		} else {
			template.addClass('md-toast-error');
		}
		simple._options.template = template[0].outerHTML.replace('{{ toast.content }}', '<pre>{{ toast.content }}</pre>');
		return $mdToast.show(simple.content($translate.instant(text)).position('left bottom right').hideDelay(delay || 4000));
	};
});

var underscore = angular.module('underscore', []);
underscore.factory('_', function() {
	return window._;
});

'use strict';

angular.module('viAdminUi')
.controller('MenuCtrl', function ($scope, authFactory, $mdSidenav, $log, $location, $translate) {
	$scope.toggleMenu = buildToggler('menu');
	$scope.customerDetails = authFactory.getCurrentUser();
	$scope.isMenuOpen = function(){
		return $mdSidenav('menu').isOpen();
	};
	$scope.logout = function () {
		authFactory.logout();
		$location.path( "/login" );
	};

	$scope.availableLocales = {
		'en': 'language.englishUS',
		'fr': 'language.french',
		'nl': 'language.dutch',
		'pl': 'language.polish',
		'it': 'language.italian',
		'de': 'language.german',
		'pt-br': 'language.portugueseBR',
		'es': 'language.spanish'
	};

	$scope.model = {selectedLocale: $translate.use() || $translate.preferredLanguage()};
	$scope.changeLocale = function (value) {
		$translate.use(value);
	};
	$scope.now = new Date();
	/**
	 * Build handler to open/close a SideNav; when animation finishes
	 * report completion in console
	 */
	function buildToggler(navID) {
		return function() {
			$mdSidenav(navID).open();
		}
	}
})
;

var module = angular.module('viAdminUi');

function BarCodeScanner(config) {
  this._stopped = false;

  var startCallbacks = [];
  var processedCallbacks = [];
  var detectedCallbacks = [];
  var errorCallbacks = [];

  this.onStart = function(callback) {
    startCallbacks.push(callback.bind(this));
  };

  this._fireStart = function() {
    this._fire(startCallbacks);
  };

  this.onProcessed = function(callback) {
    processedCallbacks.push(callback.bind(this));
  };

  this._fireProcessed = function(result) {
    this._fire(processedCallbacks, result);
  };

  this.onDetected = function(callback) {
    detectedCallbacks.push(callback.bind(this));
  };

  this._fireDetected = function(result) {
    this._fire(detectedCallbacks, result);
  };

  this.onError = function(callback) {
    errorCallbacks.push(callback.bind(this));
  };

  this._fireError = function(error) {
    this._fire(errorCallbacks, error);
  };

  this._fire = function(callbacks, parameter) {
    for (var i in callbacks) {
      callbacks[i](parameter);
    }
  };

  this._initQuagga = function(_callback) {
    var callback = _callback.bind(this);

    Quagga.init(config, function(error) {
      if (error) {
        console.error(error);

        var constraints = config.inputStream.constraints;

        if (constraints) {
          if (constraints.width || constraints.height) {
            delete constraints.width;
            delete constraints.height;

            this._initQuagga(callback);

            return;
          }
        }

        barCodeScanner._fireError(error);
        return;
      }

      callback();
    }.bind(this));
  };

  this.start = function() {
    var barCodeScanner = this;

    this._initQuagga(function() {
      Quagga.start();
      barCodeScanner._stopped = false;

      setTimeout(function() {
        this._fireStart();
      }.bind(this), 50);

    });

    Quagga.onProcessed(function(result) {
      if (barCodeScanner._stopped) {
        return;
      }

      barCodeScanner._fireProcessed(result);
    });

    Quagga.onDetected(function(result) {
      if (barCodeScanner._stopped) {
        return;
      }

      barCodeScanner._fireDetected(result);
    });

  };

  this.stop = function() {
    try {
      Quagga.stop();
    } catch(e) {
      console.error(e);
    }

    Quagga.offProcessed();
    Quagga.offDetected();

    this._stopped = true;
  }

  this.getCapabilities = function() {
    var track = Quagga.CameraAccess.getActiveTrack();

    if (!track) {
      return {};
    }

    if (!track.getCapabilities) {
      return {};
    }

    return track.getCapabilities();
  };

  this.setFlashlightOn = function(on) {
    var track = Quagga.CameraAccess.getActiveTrack();

    if (!track) {
      return false;
    }

    if (!track.applyConstraints) {
      return false;
    }

    if (on === false) {
      Quagga.stop();

      this._initQuagga(function() {
        Quagga.start();
      });

      return false;
    }

    track.applyConstraints({
      advanced: [
        {torch: true}
      ]
    });

    return true;
  };
}

module.service('barCodeScannerService', [function() {
  this.startScanner = function(_config) {
    var config = _.defaults(_config, {
      locate: false,
      inputStream : {},
      decoder : {}
    });

    config.inputStream = _.defaults(config.inputStream, {
      name : "BarCodeScanner",
      type : "LiveStream",
      constraints: {
        facingMode: "environment",
        width: 1920,
        height: 1080
      },
      area: {
        top: '45%',
        bottom: '45%'
      }
    });

    config.decoder = _.defaults(config.decoder, {
      readers: ["code_128_reader"]
    });

    var barCodeScanner = new BarCodeScanner(config);
    barCodeScanner.start();

    return barCodeScanner;
  }
}]);

function BarCodeScannerDialog() {
  this._dialogPromise = null;
  this._barCodeScanner = null;

  var callbacks = {
    processed: [],
    detected: [],
    error: [],
    start: [],
    stop: []
  };

  this._setBarCodeScanner = function(barCodeScanner) {
    barCodeScanner.onStart(this._fireStart.bind(this));
    barCodeScanner.onProcessed(this._fireProcessed.bind(this));
    barCodeScanner.onDetected(this._fireDetected.bind(this));
    barCodeScanner.onError(this._fireError.bind(this));
    this._barCodeScanner = barCodeScanner;
  };

  this._fireProcessed = function(result) {
    this._fire(callbacks.processed, result);
  }

  this._fireDetected = function(result) {
    this._fire(callbacks.detected, result);
  }

  this._fireError = function(error) {
    this._fire(callbacks.error, error);
  }

  this._fireStart = function() {
    this._fire(callbacks.start);
  };

  this._fireStop = function() {
    this._fire(callbacks.stop);
  };

  this._fire = function(callbacks, parameter) {
    for (var i in callbacks) {
      var newParameter = callbacks[i](parameter);

      if (typeof(newParameter) !== 'undefined') {
        parameter = newParameter;
      }
    }
  };

  this.onProcessed = function(callback) {
    callbacks.processed.push(callback.bind(this));
    return this;
  };

  this.onDetected = function(callback) {
    callbacks.detected.push(callback.bind(this));
    return this;
  };

  this.onError = function(callback) {
    callbacks.error.push(callback.bind(this));
    return this;
  };

  this.onStart = function(callback) {
    callbacks.start.push(callback.bind(this));
  };

  this.onStop = function(callback) {
    callbacks.stop.push(callback.bind(this));
  };

  this.stop = function() {
    if (this._barCodeScanner) {
      this._barCodeScanner.stop();
    }

    this._fireStop();
  };

  this.stopAndClose = this.stop;
  this.close = this.stop;

  this.getCapabilities = function() {
    if (!this._barCodeScanner) {
      return {};
    }

    return this._barCodeScanner.getCapabilities();
  };

  this.setFlashlightOn = function(on) {
    return this._barCodeScanner.setFlashlightOn(on);
  };
}

function BodyScrollControl() {
  var body = document.body;
  var originalStyle = body.getAttribute('style') || '';

  this.removeScroll = function() {
    body.style.overflow = 'hidden';
  };

  this.restoreScroll = function() {
    body.setAttribute('style', originalStyle);
  };
}

module.service('barCodeScannerDialogService', ['_', '$mdDialog', 'barCodeScannerService', function(_, $mdDialog, barCodeScannerService) {
  this.show = function(_config) {
    var config = _.defaults(_config, {
      dialog: {},
      barcode: {}
    });

    config.barcode = _.defaults(config.barcode, {
      inputStream: {}
    });

    var barcodeDialog = new BarCodeScannerDialog();
    var bodyScrollControl = new BodyScrollControl();

    barcodeDialog._dialogPromise = $mdDialog.show({
      targetEvent: config.dialog.targetEvent,
      parent: document.body,
      disableParentScroll: false,
      templateUrl: 'app/components/barCodeScanner/dialog.html',
      transformTemplate: function(template) {
        return template;
      },
      controller: 'BarCodeScannerDialogController',
      locals: {
        barcodeDialog: barcodeDialog
      },
      onComplete: function(scope, element) {
        bodyScrollControl.removeScroll();
        config.barcode.inputStream.target = element[0].querySelector("#barcodeVideoContainer");

        var barCodeScanner = barCodeScannerService.startScanner(config.barcode);
        barcodeDialog._setBarCodeScanner(barCodeScanner);

        barcodeDialog.onError(function() {
          this.stop();
          bodyScrollControl.restoreScroll();
        });

        barcodeDialog.onStop(function() {
          $mdDialog.hide(barcodeDialog._dialogPromise);
          bodyScrollControl.restoreScroll();
        });
      }
    }).then(function() {
      barcodeDialog.stop();
    }, function() {
      barcodeDialog.stop();
      bodyScrollControl.restoreScroll();
    });

    return barcodeDialog;
  };
}]);

module.controller('BarCodeScannerDialogController', ['$scope', '$location', 'barcodeDialog', function($scope, $location, barcodeDialog) {
  var eventType = null;

  $scope.state = {
    flashlight: {
      available: false,
      on: false
    }
  };

  $scope.closeDialog = function() {
    barcodeDialog.close();
  };

  $scope.toggleFlashLight = function(event) {
    if (!eventType) {
      eventType = event.type;
    }

    if (event.type !== eventType) {
      return;
    }

    var flashlightOn = !$scope.state.flashlight.on;
    $scope.state.flashlight.on = barcodeDialog.setFlashlightOn(flashlightOn);
  };

  barcodeDialog.onStart(function() {
    var capabilities = barcodeDialog.getCapabilities();

    $scope.state.flashlight.available = (capabilities.torch === true);
    $scope.$apply();
  });

  $scope.$on('$locationChangeStart', function (event) {
    event.preventDefault();
    $scope.closeDialog();
  });
}]);

module.service('dvrSerialNumberScannerService', ['barCodeScannerDialogService', function(barCodeScannerDialogService) {
  var SERIAL_NUMBER_PATTERNS = [];
  SERIAL_NUMBER_PATTERNS.push(/D(VR|S1|S2|M0)[0-9]{10,14}/);

  function isSerialNumberValid(serialNumber) {
    for (var i in SERIAL_NUMBER_PATTERNS) {
      var pattern = SERIAL_NUMBER_PATTERNS[i];

      if (pattern.test(serialNumber) === true) {
        return true;
      }
    }

    return false;
  }

  var dvrBarCodeDialog = null;

  this.show = function(config) {
    if (dvrBarCodeDialog) {
      return new BarCodeScannerDialog();
    }

    dvrBarCodeDialog = barCodeScannerDialogService.show(config);

    dvrBarCodeDialog.onStop(function() {
      dvrBarCodeDialog = null;
    });

    dvrBarCodeDialog.onDetected(function(result) {
      if (!result.codeResult) {
        return false;
      }

      var serialNumber = result.codeResult.code;

      if (!serialNumber) {
        return false;
      }

      if (isSerialNumberValid(serialNumber)) {
        return {
          serialNumber: serialNumber
        };
      }

      console.info(serialNumber + ' is not a valid DVR Serial Number');
      return false;
    });

    return dvrBarCodeDialog;
  };
}]);

module.service('vinScannerService', ['_', 'barCodeScannerDialogService', 'vinValidatorService', 'authFactory', function(_, barCodeScannerDialogService, vinValidatorService, authFactory) {
  var vinBarCodeDialog = null;
  var user = authFactory.getCurrentUser();

  this.show = function(_config) {
    if (vinBarCodeDialog) {
      return new BarCodeScannerDialog();
    }

    var config = _.defaults(_config, {
      barcode: {}
    });

    config.barcode = _.defaults(config.barcode, {
      decoder: {}
    });

    config.barcode.decoder.readers = ["code_39_vin_reader"];

    vinBarCodeDialog = barCodeScannerDialogService.show(config);

    vinBarCodeDialog.onStop(function() {
      vinBarCodeDialog = null;
    });

    vinBarCodeDialog.onDetected(function(result) {
      if (!result.codeResult) {
        return false;
      }

      var vin = result.codeResult.code;

      if (!vin) {
        return false;
      }

      var vinValidation = vinValidatorService.validate(vin);

      if (user.vinValidation === false) {
        return {
          vin: vin
        };
      }

      if (vinValidation.valid) {
        return {
          vin: vin
        };
      }

      console.info(vin + ' is not a valid VIN');

      if (vinValidation.error) {
        console.info(vinValidation.error);
      }

      return false;
    });

    return vinBarCodeDialog;
  };
}]);

'use strict';

var mod = angular.module("viAdminUi.services.auth", []);
mod.factory('authFactory', ['$q', '$http', '$rootScope', '$cookies', function ($q, $http, $rootScope, $cookies) {
  var userStorageKey = 'currentUser';
  var sysIdKey = 'sysId';
  var obj = {};
  obj.authenticate = function (user, pass, mode, systemId) {
    var deferred = $q.defer();
    //remote = true; local = false
    if (mode) {
      $http.post($rootScope.apiUrl + '/auth', {
        user: user,
        pass: pass
      }, {
        headers: {
          systemId: systemId
        }
      })
      .success(function (user) {
        obj.setCurrentUser(user, systemId);
        deferred.resolve(user);
      })
      .error(function (data, status) {
        deferred.reject(status);
      });
    } else {
      $rootScope.tmpUser = user;
      $rootScope.tmpPass = pass;
      $http.get('app/auth/auth.local.json')
      .success(function (adminUser) {
        var user = adminUser[$rootScope.tmpUser];
        if (user != null && user.pass === $rootScope.tmpPass) {
          obj.setCurrentUser(user, systemId);
          deferred.resolve(user);
        } else {
          deferred.reject();
        }
      });
    }
    return deferred.promise;
  };
  obj.isAuthenticated = function() {
    return $rootScope.currentUser != null;
  };
  obj.getCurrentUser = function () {
    return $rootScope.currentUser;
  };
  obj.setCurrentUser = function (user, systemId) {
    if (user != null) {
      $rootScope.currentUser = user;
      $rootScope.currentUser.systemId = systemId;
      obj.setAuthHeader(systemId);
      $cookies[userStorageKey] = JSON.stringify(user);
      $cookies[sysIdKey] = systemId;
    }else {
      delete $cookies[userStorageKey];
      $rootScope.currentUser = user;
    }
  };
  obj.logout = function () {
    obj.setCurrentUser(null);
  };
  obj.refreshUserFromLocalStorage = function () {
    var strUser = $cookies[userStorageKey];
    var systemId = $cookies[sysIdKey];

    if (strUser === undefined) {
      return;
    }

    $rootScope.currentUser = JSON.parse(strUser);
    this.setAuthHeader(systemId);
  };
  obj.setAuthHeader = function (systemId) {
    var currentUser = obj.getCurrentUser();

    $http.defaults.headers.common['Authorization'] = 'Basic ' + currentUser.auth;
    $http.defaults.headers.common['Source'] = "DVRToolkit";
    $http.defaults.headers.common['systemid'] = systemId;

    if (currentUser.customerId) {
      $http.defaults.headers.common['customerId'] = currentUser.customerId;
    }
  };
  obj.getSystems = function () {
    var url = $rootScope.apiUrl + '/systems/';
    var deferred = $q.defer();
    $http.get(url, { headers: { systemId: 'all' }}).success(function(res) {
      var result = res.data[0].map(function(e) {
        var userNameMode = e._source.userName ? e._source.userName.mode : 'cid';

        return {
          text: e._source.name,
          value: e._source.systemId,
          username: userNameMode
        };
      });
      deferred.resolve(result);
    }).error(function (data, status) {
        deferred.reject(status);
    });
    return deferred.promise;
  };
  return obj;
} ]);

'use strict';

angular.module('viAdminUi')
.controller('AuthCtrl', function ($scope, $rootScope, $location, authFactory, $cookies) {

  $scope.initPage = function () {
    $scope.credentials = {
      username: '',
      password: ''
    };
    $scope.options = {
      systemIds: []
    };
    $scope.userNameModeLabel = 'label.cid';

    var sysId = $cookies['sysId'];
    if (sysId) {
      $scope.systemId = sysId;
    }
    $scope.showLoginError = false;
    $scope.mode = !$scope.isNodeWebkit();
    $scope.loadSystems();
  }

  $scope.loadSystems = function () {
    $scope.systemsLoading = true;

    authFactory.getSystems().then(function(res) {
      $scope.systemsLoading = false;
      $scope.options.systemIds = res;

      $scope.systemId = $cookies['sysId'] || 'peoplenet';

      if ($scope.systemId) {
        $scope.updateUserNameModeLabel();
      }
    }, function (error) {
      $scope.systemsLoading = false;
      console.error(error);
    });
  }

  $scope.updateUserNameModeLabel = function () {
    if ($scope.systemId) {
      var systemSelected = $scope.options.systemIds.filter(function(system){
        return system.value === $scope.systemId;
      });

      $scope.userNameModeLabel = systemSelected[0].username === 'username' ? 'label.userName' : 'label.cid';
      $scope.displayNewPolicies = $scope.systemId === 'peoplenet' || $scope.systemId === 'togs';
    }
  }

  $scope.login = function () {
    $scope.showLoginError = false;
    authFactory.logout();
    authFactory.authenticate($scope.credentials.user, $scope.credentials.password, $scope.mode, $scope.systemId).then(function (user) {
      if (user.role == 'installer' && $scope.mode) {
        $location.path('/activation');
      } else {
        $location.path('/');
      }
    }, function (error) {
      $scope.showLoginError = true;
    });
  };

  $scope.initPage();
});

'use strict';
//TODO: declare factory on same module viAdminUi.services
var mod = angular.module("viAdminUi.services.main", []);

mod.factory('main.validation', function() {
	var obj = {};
	var validation = {
		actions: {
			validate: 'validate',
			ignore: 'ignore',
			remove: 'remove',
			deep: 'deep'
		},
		type: {
			values: 'values',
			minMax: 'minMax',
			len: 'len',
			array: 'array'
		}
	};
	var json = {
		videoChannelConfig: {
			action: validation.actions.deep,
			required: false,
			child: {
				mirrorEnable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				flipEnable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				rcMode: {
					action: validation.actions.ignore,
					required: false
				},
				maxQp: {
					action: validation.actions.ignore,
					required: false
				},
				minQp: {
					action: validation.actions.ignore,
					required: false
				},
				fixQp: {
					action: validation.actions.ignore,
					required: false
				},
				channelId : {
					action: validation.actions.ignore,
					required: false
				},
				bitrate: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [48, 96 ,128, 192, 256, 384, 512, 640, 768, 1000, 1250, 1280, 1500, 1750, 2000]
					}
				},
				framerate: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 1,
						max: 30
					}
				},
				resolution: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: ['CIF', 'D1', '720P', '1080P']
					}
				},
				audioEnabled: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				OSDEnabled: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				OSDMirrored: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				}
			}
		},
		dvrIdentification: {
			action: validation.actions.deep,
			required: false,
			child: {
				cid: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.len,
						len: 15
					}
				},
				vehicleNum: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.len,
						len: 30
					}
				},
				serialNo: {
					action: validation.actions.remove
				},
				version: {
					action: validation.actions.remove
				},
				svNum: {
					action: validation.actions.remove
				},
				dsn: {
					action: validation.actions.remove
				},
				triggerType: {
					action: validation.actions.remove
				},
				mcuId: {
					action: validation.actions.remove
				},
				machineType: {
					action: validation.actions.ignore,
					required: false
				}
			}
		},
		networkConfig: {
			action: validation.actions.deep,
			required: false,
			child: {
				ethernet: {
					action: validation.actions.deep,
					required: false,
					child: {
						ipAddress: {
							action: validation.actions.ignore,
							required: false
						},
						macAddress: {
							action: validation.actions.remove,
						},
						subnetMask: {
							action: validation.actions.ignore,
							required: false
						},
						dnsServer: {
							action: validation.actions.ignore,
							required: false
						},
						"ap": {
							action: validation.actions.deep,
							child: {
								enable: {
									action: validation.actions.validate,
									required: false,
									validation: {
										type: validation.type.values,
										values: [true, false]
									}
								},
								frequency: {
									action: validation.actions.ignore,
									required: false
								}
							}
						}
					}
				},
				wifi: {
					action: validation.actions.deep,
					required: false,
					child: {
						ssid: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.len,
								len: 15
							}
						},
						authmode: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.values,
								values: ['AUTO', 'WPAPSK', 'WPA2PSK', 'SHARED', 'OPEN']
							}
						},
						encryption: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.values,
								values: ['AES', 'NONE', 'AUTO', 'WEP', 'TKIP']
							}
						},
						password: {
							action: validation.actions.ignore,
							required: false
						},
						extraWifiList: {
							action: validation.actions.ignore,
							required: false
						},
						enable: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.values,
								values: [true, false]
							}
						}
					}
				},
				cellular: {
					action: validation.actions.deep,
					required: false,
					child: {
						enabled: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.values,
								values: [true, false]
							}
						},
						apn: {
							action: validation.actions.ignore,
							required: false
						}
					}
				},
				webUiEnable: {
					action: validation.actions.ignore,
					required: false
				}
			}
		},
		mediaDeliveryConfig: {
			action: validation.actions.deep,
			required: false,
			child: {
				url: {
					action: validation.actions.ignore,
					required: false
				},
				accessKey: {
					action: validation.actions.ignore,
					required: false
				},
				secretKey: {
					action: validation.actions.ignore,
					required: false
				},
				sslEnable: {
					action: validation.actions.ignore
				}
			}
		},
		managementServerConfig: {
			action: validation.actions.deep,
			required: false,
			child: {
				url: {
					action: validation.actions.ignore,
					required: false
				},
				user: {
					action: validation.actions.ignore,
					required: false
				},
				password: {
					action: validation.actions.ignore,
					required: false
				}
			}
		},
		gpioConfig : {
			action: validation.actions.ignore
		},
		peripheral: {
			action: validation.actions.ignore,
			required: false
		},
		recordingSettings: {
			action: validation.actions.deep,
			required: false,
			child: {
				jpegEnableArray: {
					action: validation.actions.ignore,
					required: false
				},
				sdLockIgnore: {
					action: validation.actions.ignore,
					required: false
				},
				storageEnableArray: {
					action: validation.actions.ignore,
					required: false
				},
				maxClipNum: {
					action: validation.actions.ignore,
					required: false
				},
				recStatistic: {
					action: validation.actions.ignore,
					required: false
				},
				clipGenerating_Limit: {
					action: validation.actions.ignore,
					required: false
				},
				backupVideoEnable: {
					action: validation.actions.ignore,
					required: false
				},
				loopFileMinutes: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [5, 10, 15, 20, 25, 30]
					}
				},
				eventBufferPct: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 1,
						max: 99
					}
				},
				continueLoopWaterLevel: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 501,
						max: 999
					}
				},
				recEnableArray: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.array,
						values: [0, 1]
					}
				},
				diffCardBackRec: {
					action: validation.actions.ignore,
					required: false
				}
			}
		},
		eventConfig: {
			action: validation.actions.deep,
			required: false,
			child: {
				preSeconds: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 1,
						max: 899
					}
				},
				postSeconds: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 1,
						max: 899
					}
				},
				channel1Enable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				channel2Enable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				channel3Enable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				channel4Enable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				convertEnable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				bitrate: {

					action: validation.actions.deep,
					child: {
						resolution: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.values,
								values: [0, 1, 2, 3, 4]
							}
						},
						audioEnable: {
							action: validation.actions.validate,
							required: false,
							validation: {
								type: validation.type.values,
								values: [0, 1]
							}
						}
					}
				}
			}
		},
		timeConfig: {
			action: validation.actions.deep,
			required: false,
			child: {
				ntpIntervalMinutes: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 0,
						max: 1800
					}
				},
				ntpServer: {
					action: validation.actions.ignore,
					required: false
				},
				gpsSyncBackup: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				}
			}
		},
		accConfig: {
			action: validation.actions.deep,
			child: {
				delaySec: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 0,
						max: 43200
					}
				},
				poweroffVoltage: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 0
					}
				}
			}
		},
		rtcRepair: {
			action: validation.actions.ignore,
			required: false
		},
		logConfig: {
			action: validation.actions.deep,
			child: {
				recLevel: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 0
					}
				},
				uploadLevel: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: 0
					}
				},
				gpsLog: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				mcuLogOutput: {
					action: validation.actions.ignore,
					required: false
				},
				gsensorLog: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				tcpDumpEnable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				},
				kmsgDumpEnable: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.values,
						values: [true, false]
					}
				}
			}
		},
		imageParam: {
			action: validation.actions.deep,
			child: {
				brightness: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: -1,
						max: 255
					}
				},
				contrast: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: -1,
						max: 255
					}
				},
				hue: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: -1,
						max: 255
					}
				},
				saturation: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: -1,
						max: 255
					}
				},
				sharpness: {
					action: validation.actions.validate,
					required: false,
					validation: {
						type: validation.type.minMax,
						min: -1,
						max: 255
					}
				}
			}
		}
	};
	obj.validation = validation;
	obj.schema = json;
	obj.validateJson = function (text, checkConfiguration) {
		//validate structure
		var inputObj = {};
		try {
			inputObj = JSON.parse(text);
		} catch (e) {
			return {
				error: e.message
			};
		}
		if (checkConfiguration) {
			return doValidateJson(obj.schema, inputObj);
		} else {
			return inputObj;
		}
	}

	function doValidateJson(schema, inputObj) {
		if (Array.isArray(inputObj)) {
			for (var i = 0; i < inputObj.length; i++) {
				var res = doValidateJson(schema, inputObj[i]);
				if(res.error)
					return res;
			}
		}else {
			for (var propName in inputObj) {
				if (!schema.hasOwnProperty(propName)) {
					return {
						error: "Unknown property: " + propName
					}
				}
				var schemaElement = schema[propName];
				if (schemaElement.action === validation.actions.deep) {
					var res = doValidateJson(schemaElement.child, inputObj[propName]);
					if (res.error)
						return res;
				} else if (schemaElement.action === validation.actions.ignore) {
					continue;
				} else if (schemaElement.action === validation.actions.validate) {
					if (inputObj[propName] == null) {
						delete inputObj[propName];
						continue;
					}
					if (schemaElement.validation.type === validation.type.values) {
						if (schemaElement.validation.values.indexOf(inputObj[propName]) === -1) {
							return {
								error: "Invalid value: " + inputObj[propName] + " for property: " + propName
							}
						}
					} else if (schemaElement.validation.type === validation.type.minMax) {
						if (isNaN(parseFloat(inputObj[propName]))) {
							return {
								error: "Invalid value: " + obj.schema[name] + " should be numeric: " + propName
							}
						}
						var valAux = parseFloat(inputObj[propName]);
						if (schemaElement.validation.max && valAux > schemaElement.validation.max) {
							return {
								error: "Invalid value: " + valAux + " max value: " + schemaElement.validation.max
							}
						}
						if (schemaElement.validation.min && valAux < schemaElement.validation.min) {
							return {
								error: "Invalid value: " + valAux + " minMax value: " + schemaElement.validation.min
							}
						}
					} else if (schemaElement.validation.type === validation.type.len) {
						if (inputObj[propName].toString().trim().length >= schemaElement.validation.len) {
							return {
								error: "Invalid value: " + valAux + " max-lenght: " + schemaElement.validation.len
							}
						}
					} else if (schemaElement.validation.type === validation.type.array) {
						var valAux = inputObj[propName];
						if(!_.isArray(valAux)) {
							return {
								error: "Invalid type: " + propName + " should be an array"
							}
						}
						var valid = _.every(valAux, function(e) {
							return _.contains(schemaElement.validation.values, e);
						});
						if(!valid) {
							return {
								error: "Invalid value: " + valAux + " should contains only " + schemaElement.validation.values
							}
						}
					}else if (inputObj[propName].toString().length >= schemaElement.validation.len) {
						return {
							error: "Invalid value: " + valAux + " max-lenght: " + schemaElement.validation.len
						}
					}
				} else if (schemaElement.action === validation.actions.remove) {
					delete inputObj[propName];
				}
			}
		}
		return inputObj;
	}
	return obj
});

mod.factory('mainFactory', function ($q, $http, $rootScope) {
	var obj = {};
	obj.getCamerasSnap = function (serialNo, customerId, machineType, trigger) {
		if (customerId !== null && trigger) {
			return $http.get($rootScope.apiUrl + '/dvr/' + serialNo + '/snaps?customerId=' + customerId + '&machineType=' + machineType);	
		} else {
			return $http.get($rootScope.apiUrl + '/dvr/' + serialNo + '/snaps');
		}
	};
	obj.getCameraSnap = function (serialNo, camera) {
		return $http.get($rootScope.apiUrl + '/provider/1/dvr/'+ serial + '/camera/' + camera);
	};
	obj.getPreConfigCustomerJson = function (customer, config) {
		var deferred = $q.defer();
		var url = '/customer/' + customer + '/config/' + config;
		$http.get(url)
		.success(function(json) {
			deferred.resolve(json);
		})
		.error(function (data, status) {
			deferred.reject(status);
		});
		return deferred.promise;
	};
	obj.setPreConfigCustomerJson = function (config) {
		var deferred = $q.defer();
		$http.post('/provider/1/config', config)
		.success(function(json) {
			deferred.resolve(json);
		})
		.error(function (data, status) {
			deferred.reject(status);
		});
		return deferred.promise;
	};
	obj.getSDCardState = function (dvr, mode, action) {
		var data = {
			localApi: {
				password: "sharpvision"
			}
		};

		return $http.get(getSDCardStateUrl(mode, dvr, action), data).then(function(response) {
			var result = response.data;

			if (typeof(result) === 'string') {
				return JSON.parse(result);
			}

			return result;
		}).catch(function (response) {
			var result = response.data;

			if (!result) {
				result = {};
			} else if (typeof(result) === 'string') {
				result = JSON.parse(result);
			}

			if (response.status === 404) {
				result.isOffline = true;
				return result;
			}

			if (result.errorType === 247) {
				result.isDoorOpen = (result.errorType === 247);
				return result;
			}

			throw result;
		});
	};
	obj.getPreConfigCustomerNames = function (mode) {
		var deferred = $q.defer();
		$http.get('/provider/1/config/'+ mode)
		.success(function (data) {
			deferred.resolve(data);
		})
		.error(function (data, status) {
			deferred.reject(status);
		});
		return deferred.promise;
	};
	obj.getDvrConfig = function (search, role) {
		var deferred = $q.defer();
		var urlConfig = getUrlConfig(search.mode, search.value);
		var countRetry = 0;
		var doGet = function (urlConfig) {
			$http.get(getUrlConfig(search.mode, search.value, role))
			.success(function (dvrConfig, status, headers) {
				if (dvrConfig["@request_error@"] != null || dvrConfig.errorType != null || headers('Content-Type') == "text/plain") {
					var timeout = window.setTimeout(function() {
						//retry 10 times.
						if (countRetry === 10) {
							deferred.reject('device offline');
							clearTimeout(timeout);
							return;
						}
						countRetry++;
						doGet(urlConfig);
					}, 1000);
				}else {
					deferred.resolve(dvrConfig);
				}
			})
			.error(function (data, status) {
				deferred.reject(status);
			});
		}
		doGet();
		return deferred.promise;
	};

	obj.link = function (serial, obj, type) {
		var deferred = $q.defer();
		var url = $rootScope.apiUrl + '/vehicle/' + serial + (type ? '/link' : '/unlink');
		$http.post(url, obj)
		.success(function () {
			deferred.resolve();
		})
		.error(function () {
			deferred.reject();
		});
		return deferred.promise;
	}

	obj.postDvrConfig = function (dvr, data) {
		var deferred = $q.defer();
		data.localApi = { password: "sharpvision" };

		//TODO check mode here and send to other ip
		$http.post(getUrlConfig(dvr.mode, dvr.value), data)
		.success(function (dvrConfig) {
			deferred.resolve(dvrConfig);
		})
		.error(function (data, status) {
			deferred.reject(data, status);
		});
		return deferred.promise;
	};

	obj.formatSd = function (dvr, value) {
		var deferred = $q.defer();
		var data = {
			localApi: {
				password: "sharpvision"
			}
		};

		$http.post(getFormatUrl(dvr, value), data)
		.success(function (result) {
			deferred.resolve(result);
		})
		.error(function (data, status) {
			deferred.reject(status);
		});
		return deferred.promise;
	};

	obj.uploadFirmware = function (serial, data) {
		var deferred = $q.defer();

		var url = $rootScope.apiUrl + '/vehicle/' + serial + '/firmware/url';
		$http.post(url, data)
		.success(function (data) {
			deferred.resolve(data);
		})
		.error(function (data, status) {
			deferred.reject(status);
		});
		return deferred.promise;
	};

	obj.getCustomerList = function () {
		var deferred = $q.defer();

		var url = $rootScope.apiUrl + '/customer/list';
		$http.get(url)
		.success(function (data) {
			deferred.resolve(data);
		})
		.error(function (data, status) {
			deferred.reject(status);
		});
		return deferred.promise;
	};

	function getFormatUrl(dvr, value) {
		var url = '';
		if (dvr.mode === 'ip') {
			$rootScope.localDvrUrl = '';
			if (value.indexOf('://') === -1) {
				$rootScope.localDvrUrl = 'http://';
			}
			$rootScope.localDvrUrl += dvr.value;
			url = $rootScope.localDvrUrl + ':8080/formatSD';
		} else {
			url = $rootScope.apiUrl + '/vehicle/' + value + '/format?type=' + dvr.mode;
		}
		return url;
	}

	function getUrlConfig(mode, value, role) {
		var url = '';
		if (mode === 'ip') {
			$rootScope.localDvrUrl = '';
			if (value.indexOf('://') === -1) {
				$rootScope.localDvrUrl = 'http://';
			}
			$rootScope.localDvrUrl += value;
			url = $rootScope.localDvrUrl + ':8080/config';
		} else {
			url = $rootScope.apiUrl + '/vehicle/' + value + '/config?type=' + mode;
		}

		if (role == "installer") {
			url += '&role=installer';
		}

		return url;
	}

	function getSDCardStateUrl(mode, value, action) {
		// TODO: LOCAL MODE may soon be discontinued.
		var url = $rootScope.apiUrl + '/provider/1/dvr/' + value + '/sd/status?type=' + mode;
		if (action) {
			url += '&action=' + action;
		}
		return url;
	}
	return obj;
});

'use strict';

angular.module('viAdminUi')
.controller('MainCtrl', ['$scope', 'mainFactory', 'authFactory', 'main.validation', '$mdToast', '$q', '$location', '$translate', function ($scope, mainFactory, authFactory, validation, $mdToast, $q, $location, $translate) {

	var user = authFactory.getCurrentUser();
	if (user == null || user.role != 'admin') {
		//not authorized
		$location.path('/login');
		return;
	}

	//init
	$scope.search = {};
	$scope.tabs = {};
	$scope.tabs.enabled = {};
	$scope.tabs.json = {};
	$scope.tabs.json.enabled = {};
	$scope.tabs.obj = {};
	$scope.tabs.watchers = {};
	$scope.obj = {};
	$scope.json = {}
	$scope.uploadConfig = {
		check: true
	};

	$scope.modes = {
		ip: 'ip',
		dsn: 'dsn',
		serial: 'serial'
	};

	//default mode: dsn
	if (authFactory.getCurrentUser().mode !== 'local') {
		$scope.search.mode = $scope.modes.dsn;
	} else {
		$scope.search.mode = $scope.modes.ip;
	}

	$scope.tabs.enabled.dvrIdentification = true;
	$scope.tabs.enabled.dvrVideoChannelConfig = true;
	$scope.tabs.enabled.dvrNetworkConfig = true;
	$scope.tabs.enabled.dvrEventConfig = true;
	$scope.tabs.enabled.dvrTimeConfig = true;
	$scope.tabs.enabled.dvrRecordingSettings = true;
	$scope.tabs.enabled.dvrSetup = true;
	$scope.tabs.enabled.dvrAccConfig = true;
	$scope.tabs.enabled.dvrLogging = true;
	$scope.tabs.enabled.dvrAdvanced = true;
	$scope.tabs.enabled.dvrManagement = true;

	if (authFactory.getCurrentUser().role === 'installer') {
		$scope.tabs.enabled.dvrVideoChannelConfig = false;
		$scope.tabs.enabled.dvrNetworkConfig = false;
		$scope.tabs.enabled.dvrEventConfig = false;
		$scope.tabs.enabled.dvrTimeConfig = false;
		$scope.tabs.enabled.dvrRecordingSettings = false;
		$scope.tabs.enabled.dvrSetup = false;
		$scope.tabs.enabled.dvrAccConfig = false;
		$scope.tabs.enabled.dvrLogging = false;
		$scope.tabs.enabled.dvrAdvanced = false;
		$scope.tabs.enabled.dvrManagement = false;
	}

	$scope.dvr = null;
	$scope.showLoading = false;
	$scope.showParserError = false;
	$scope.showSaveConfiguration = false;
	$scope.tabSelected = 0;
	$scope.errorMsgTemplates = {
		InvalidValue: '{0} is not a valid option for {1}.',
		MalformatedJson: 'Malformatted json string.',
		InvalidProperty: '{0} is not a valid property.'
	};

	//TODO: unite validations with factory
	$scope.options = {
		loopFileMinutes: [15, 20, 25, 30],
		bitrate: [48, 96 ,128, 192, 256, 384, 512, 640, 768, 1000, 1250, 1280, 1500, 1750, 2000],
		framerate: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
		resolution: [{ name: 'CIF (352x240)', value: 'CIF' }, { name: 'D1 (704x480)', value: 'D1' }],
		audioEnabled: ['true', 'false'],
		celullarEnabled: ['true', 'false'],
		wifiSecurity: ['AUTO', 'NONE', 'AES'],
		channedEnabled: ['true', 'false'],
		wifiEnable: ['true', 'false'],
		recordChannelEnabled: [{ name: 'true', value: 1 }, { name: 'false', value: 0 }],
		triggerTypes: [
			{ text: 'main.dvr.trigger.serial', value: 'serial' },
			{ text: 'main.dvr.trigger.gpio', value: 'gpio'},
			{ text: 'main.dvr.trigger.eFetch', value: 'efetch' },
			{ text: 'main.dvr.trigger.onDemand', value: 'ondemand' },
			{ text: 'main.dvr.trigger.none', value: null }
		],
		osdEnabled: ['true', 'false'],
		osdMirrored: ['true', 'false'],
		gpsLog: ['true', 'false'],
		gsensorLog: ['true', 'false'],
		tcpDumpEnable: ['true', 'false'],
		kmsgDumpEnable: ['true', 'false'],
		gpsSyncBackup: ['true', 'false']
	};

	$scope.getMode = function () {
		if (authFactory.getCurrentUser()) {
			return authFactory.getCurrentUser().mode
		}
		return 'remote';
	};

	$scope.predefinedCustomerNamesList = []
	$scope.getPreConfigCustomerNames = function (callback) {
		mainFactory.getPreConfigCustomerNames($scope.getMode()).then(function (data) {
			$scope.predefinedCustomerNamesList = data.config;
			$scope.updatedDate = new Date(data.updated).toLocaleString();
			if (callback)
				callback();
		});
	};
	$scope.getPreConfigCustomerNames();

	$scope.customerList = [];
	$scope.getCustomerList = function () {
		$scope.showLoading = true;
		mainFactory.getCustomerList().then(function (res) {
			$scope.customerList = res.hits.hits.map(function (e) {
        var customerId = (e.fields.customerId ? e.fields.customerId[0] : e.fields.cid[0]);
        return { id: customerId, value: e.fields.companyName[0]}
      });
			$scope.showLoading = false;
		});
	};

	//show - show/hide
	$scope.showSaveConfigurationPanel = function () {
		$scope.showSaveConfiguration = !$scope.showSaveConfiguration;
		$scope.configuration = {
			name: '',
			customer: 0
		};

		if ($scope.showSaveConfiguration) {
			$scope.getCustomerList();
		}else {
			$scope.configuration.name = '';
			$scope.configuration.customer = JSON.stringify({ value: 'Default', id: -1, });
			if (this.saveConfig) this.saveConfig.$setUntouched();
			if (this.saveConfigPreview) this.saveConfigPreview.$setUntouched();
		}
	};

	$scope.loadConfigPreview = function (customer, config) {
		if(customer.length > 0 && config.length > 0) {
			$scope.showLoading = true;
			mainFactory.getPreConfigCustomerJson(customer[0].id, config[0].name).then(function (data) {
				$scope.showLoading = false;
				$scope.tabs.obj.preview = data;
				$scope.tabs.json.preview = JSON.stringify($scope.tabs.obj.preview, null, 4);
			});
		}else {
			$scope.tabs.obj.preview = null;
		}
	};

	$scope.changeCustomerList = function () {
		$scope.tabs.obj.preview = null;
	};

	$scope.loadFile = function (e) {
		$scope.$apply(function () {
           	$scope.showLoading = true;
           	$scope.tabs.obj.preview = null;
			$scope.tabs.json.preview = JSON.stringify($scope.tabs.obj.preview, null, 4);

			if (e.files.length > 0) {
				var fr = new FileReader();
				var onload = function (a) {
					$scope.$apply(function () {
						var result = validation.validateJson(a.target.result, $scope.uploadConfig.check);
						if (!result.error) {
							$scope.tabs.obj.preview = result;
							$scope.tabs.json.preview = JSON.stringify($scope.tabs.obj.preview, null, 4);
						}else {
							$scope.showSimpleToast(result.error, false);
						}
						$scope.showLoading = false;
					});
				}
				fr.onload = onload;
				fr.readAsText(e.files[0]);
			}
		});
	}
	//true to link, false to unlink
	$scope.link = function (type) {
		$scope.showLoading = true;
		var obj = angular.copy($scope.tabs.obj.dvrIdentification);
		obj.link = type;

		$scope.doPostData('dvrIdentification', JSON.stringify(obj), (type ? 'main.dvr.label.linked' : 'main.dvr.label.unLinked'));
	}

	$scope.uploadFirmware = function (url) {
		$scope.confirmPost().then(function() {
			$scope.showLoading = true;
			mainFactory.uploadFirmware($scope.obj.dvr.dvrIdentification.serialNo, { url: url }).then(function () {
				$scope.showLoading = false;
				$scope.showSimpleToast('main.dvr.toast.label.firmwareUpdated', true);
			}, function error(status) {
				$scope.showLoading = false;
				$scope.showSimpleToast('main.dvr.toast.firmwareUpdate.error', false);
			});
		});
	}

	$scope.formatSd = function () {
		$scope.confirmPost().then(function() {
			$scope.showLoading = true;
			mainFactory.formatSd($scope.dvr, $scope.obj.dvr.dvrIdentification.serialNo).then(function (result) {
				$scope.getConfig().then(function () {
					$scope.showSimpleToast('main.dvr.toast.sdCardFormat.success', true);
				}, function () {
					$scope.showSimpleToast('main.dvr.toast.sdCardFormat.failed', false);
				});
			}, function error(status) {
				$scope.showLoading = false;
				$scope.showSimpleToast('main.dvr.toast.sdCardFormat.failed', false);
			});
		});
	}

	$scope.saveConfiguration = function (data) {
		var customer;
		if ($scope.configuration.customer == 0) {
			customer = {
				id: 0,
				value: 'Default'
			};
		}else {
			customer = JSON.parse($scope.configuration.customer);
		}

		var config = {
			customer: {
				name: customer.value,
				id: customer.id
			},
			name: $scope.configuration.name,
			data: JSON.parse(data)
		}
		$scope.showLoading = true;
		mainFactory.setPreConfigCustomerJson(config).then(function () {
			$scope.showSimpleToast('main.dvr.toast.saveConfig', true);
			setTimeout(function() {
				$scope.getPreConfigCustomerNames(function() {
					//hide
					$scope.showSaveConfigurationPanel();
					$scope.showLoading = false;
				});
			}, 1000);
		});
	}

	$scope.downloadConfiguration = function ($event, content) {
		//ie
		if(window.navigator.msSaveOrOpenBlob) {
			window.navigator.msSaveOrOpenBlob(new Blob([content]), angular.element($event.currentTarget).attr('download'));
		} else {
			//browsers
			angular.element($event.currentTarget).attr("href", "data:text/plain;charset=utf-8," + encodeURIComponent(content));
		}
	};

	$scope.doPostData = function (key, value, feedbackMessage) {
		var strValue = '';
		if (key != "") {
			strValue = '{"' + key + '":' + value +'}';
		} else {
			strValue = value;
		}
		var objValue = JSON.parse(strValue);
		$scope.showLoading = true;
		$scope.showDeviceError = false;
		$scope.successPosting = false;

		mainFactory.postDvrConfig($scope.dvr, objValue).then(function() {
			$scope.getConfig();
			$scope.showSimpleToast(feedbackMessage || 'activation.dvr.toast.update.success', true);
		}, function error(data, status) {
			$scope.showLoading = false;
			if (data && data.meta && data.meta.error && Array.isArray(data.meta.error.errors) && data.meta.error.errors.length > 0) {
				$scope.showSimpleToast(data.meta.error.errors.join('\n'), false, 10000);
			} else {
				//generic error
				$scope.showSimpleToast('main.dvr.toast.dvrUpdate.failed', false);
			}
		});
	};
	$scope.postData = function (key, value, confirmFirst) {
		if(confirmFirst === true) {
			$scope.confirmPost().then(function(){
				$scope.doPostData(key, value);
			});
		}else {
			$scope.doPostData(key, value);
		}
	};

	$scope.confirmPost = function() {
		var confirm = $scope.$mdDialog.confirm({
			parent: (angular.element(document.body)),
			title: $translate.instant('label.warning'),
			content: $translate.instant('main.dvr.dialog.configChange.content'),
			ok: $translate.instant('label.continue'),
			cancel: $translate.instant('label.abort')
		});
		return $scope.$mdDialog.show(confirm);
	}

	$scope.getConfig = function () {
		var deferred = $q.defer();
		if($scope.search.value != null) {
			//clean
			$scope.tabs.json = {};
			$scope.tabs.obj = {};
			$scope.obj = {};
			$scope.json = {}

			$scope.dvr = null;
			$scope.showLoading = true;
			$scope.showEmptyDsn = false;
			$scope.showDeviceError = false;
			$scope.serialNumberSet = false;
			$scope.dsnSet = false;

			if ($scope.search.mode === $scope.modes.ip) {
				var ipParts = $scope.search.value.split('.');
				if(ipParts.length != 4) {
					$scope.showLoading = false;
					$scope.showSimpleToast('main.dvr.toast.getConfig.ip.error', false);
					return;
				}
				ipParts[0] = parseInt(ipParts[0]);
				ipParts[1] = parseInt(ipParts[1]);
				ipParts[2] = parseInt(ipParts[2]);
				ipParts[3] = parseInt(ipParts[3]);

				if (isNaN(ipParts[0]) || isNaN(ipParts[1]) || isNaN(ipParts[2]) || isNaN(ipParts[3])) {
					$scope.showLoading = false;
					$scope.showSimpleToast('main.dvr.toast.getConfig.ip.error', false);
					return;
				}
				$scope.search.value = ipParts.join('.');
			}

			mainFactory.getDvrConfig($scope.search).then(function (dvrConfig) {
				$scope.dvr = $scope.search;
				$scope.obj.dvr = dvrConfig;
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, null, 4);

				//serial number
				if ($scope.obj.dvr.dvrIdentification.serialNo != null &&
					$scope.obj.dvr.dvrIdentification.serialNo.toString().trim().length > 0) {
					$scope.serialNumberSet = true;
				}

				//dsn
				if ($scope.obj.dvr.dvrIdentification.dsn != null) {
					$scope.dsnSet = true;
				}

				$scope.tabs.obj.dvrIdentification = $scope.obj.dvr.dvrIdentification;
				$scope.tabs.obj.dvrVideoChannelConfig = $scope.obj.dvr.videoChannelConfig;
				$scope.tabs.obj.dvrNetworkConfig = $scope.obj.dvr.networkConfig;
				$scope.tabs.obj.dvrEventConfig = $scope.obj.dvr.eventConfig;
				$scope.tabs.obj.dvrTimeConfig = $scope.obj.dvr.timeConfig;
				$scope.tabs.obj.dvrRecordingSettings = $scope.obj.dvr.recordingSettings;
				$scope.tabs.obj.dvrMediaDeliveryConfig = $scope.obj.dvr.mediaDeliveryConfig;
				$scope.tabs.obj.dvrManagementServerConfig = $scope.obj.dvr.managementServerConfig;
				$scope.tabs.obj.accConfig = $scope.obj.dvr.accConfig;
				$scope.tabs.obj.logConfig = $scope.obj.dvr.logConfig;

				$scope.tabs.json.dvrIdentification = JSON.stringify($scope.tabs.obj.dvrIdentification, fixAngularBoolean, 4);
				$scope.tabs.json.dvrVideoChannelConfig = JSON.stringify($scope.tabs.obj.dvrVideoChannelConfig, fixAngularBoolean, 4);
				$scope.tabs.json.dvrNetworkConfig = JSON.stringify($scope.tabs.obj.dvrNetworkConfig, fixAngularBoolean, 4);
				$scope.tabs.json.dvrEventConfig = JSON.stringify($scope.tabs.obj.dvrEventConfig, fixAngularBoolean, 4);
				$scope.tabs.json.dvrTimeConfig = JSON.stringify($scope.tabs.obj.dvrTimeConfig, fixAngularBoolean, 4);
				$scope.tabs.json.dvrRecordingSettings = JSON.stringify($scope.tabs.obj.dvrRecordingSettings, fixAngularBoolean, 4);
				$scope.tabs.json.dvrMediaDeliveryConfig = JSON.stringify($scope.tabs.obj.dvrMediaDeliveryConfig, fixAngularBoolean, 4);
				$scope.tabs.json.dvrManagementServerConfig = JSON.stringify($scope.tabs.obj.dvrManagementServerConfig, fixAngularBoolean, 4);
				$scope.tabs.json.accConfig = JSON.stringify($scope.tabs.obj.accConfig, fixAngularBoolean, 4);
				$scope.tabs.json.logConfig = JSON.stringify($scope.tabs.obj.logConfig, fixAngularBoolean, 4);

				addWatchers();

				$scope.showLoading = false;
				deferred.resolve(true);
			}, function (error) {
				$scope.showLoading = false;
				$scope.showDeviceError = true;
				deferred.reject(error);
			});
		}else {
			$scope.showEmptyDsn = true;
		}
		return deferred.promise;
	};

	function fixAngularBoolean (key, value) {
		if (value === "true") {
			return true;
		} else if(value === "false"){
			return false;
		}
		if (key != '$$hashKey')
			return value;
	}

	function addWatchers () {
		if ($scope.tabs.watchers.dvrVideoChannelConfig === undefined) {
			$scope.tabs.watchers.dvrVideoChannelConfig = $scope.$watch('tabs.obj.dvrVideoChannelConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrVideoChannelConfig = JSON.stringify($scope.tabs.obj.dvrVideoChannelConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean , 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrIdentification === undefined) {
			$scope.tabs.watchers.dvrIdentification = $scope.$watch('tabs.obj.dvrIdentification', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrIdentification = JSON.stringify($scope.tabs.obj.dvrIdentification, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrRecordingSettings === undefined) {
			$scope.tabs.watchers.dvrRecordingSettings = $scope.$watch('tabs.obj.dvrRecordingSettings', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrRecordingSettings = JSON.stringify($scope.tabs.obj.dvrRecordingSettings, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrTimeConfig === undefined) {
			$scope.tabs.watchers.dvrTimeConfig = $scope.$watch('tabs.obj.dvrTimeConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrTimeConfig = JSON.stringify($scope.tabs.obj.dvrTimeConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrEventConfig === undefined) {
			$scope.tabs.watchers.dvrEventConfig = $scope.$watch('tabs.obj.dvrEventConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrEventConfig = JSON.stringify($scope.tabs.obj.dvrEventConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrMediaDeliveryConfig === undefined) {
			$scope.tabs.watchers.dvrMediaDeliveryConfig = $scope.$watch('tabs.obj.dvrMediaDeliveryConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrMediaDeliveryConfig = JSON.stringify($scope.tabs.obj.dvrMediaDeliveryConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrManagementServerConfig === undefined) {
			$scope.tabs.watchers.dvrManagementServerConfig = $scope.$watch('tabs.obj.dvrManagementServerConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrManagementServerConfig = JSON.stringify($scope.tabs.obj.dvrManagementServerConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.dvrNetworkConfig === undefined) {
			$scope.tabs.watchers.dvrNetworkConfig = $scope.$watch('tabs.obj.dvrNetworkConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.dvrNetworkConfig = JSON.stringify($scope.tabs.obj.dvrNetworkConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.accConfig === undefined) {
			$scope.tabs.watchers.accConfig = $scope.$watch('tabs.obj.accConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.accConfig = JSON.stringify($scope.tabs.obj.accConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
		if ($scope.tabs.watchers.logConfig === undefined) {
			$scope.tabs.watchers.logConfig = $scope.$watch('tabs.obj.logConfig', function (newValue, oldValue) {
				if(newValue == null || oldValue == null || angular.toJson(oldValue) == angular.toJson(newValue))
					return;
				$scope.tabs.json.logConfig = JSON.stringify($scope.tabs.obj.logConfig, fixAngularBoolean, 4);
				$scope.json.dvr = JSON.stringify($scope.obj.dvr, fixAngularBoolean, 4);
			}, true);
		}
	}
}]);

'use strict';

var mod = angular.module("viAdminUi.services.activation", []);
mod.factory('activationFactory', function ($q, $http, $rootScope) {
    var obj = {};
    obj.searchAutocomplete = function (value, _mode) {
        var deferred = $q.defer();
        var mode = _mode;
        var url = $rootScope.apiUrl + '/vehicle/' + value + '/search?type=' + mode;
        $http.get(url).success(function (res) {
            var result = res.data.map(function(e) {
                if (mode == 'serial') {
                    return {
                        id: e.serialNo,
                        display: e.serialNo
                    };
                } else if (mode == 'vehicle') {
                    return {
                        id: e.vehicle,
                        display: e.vehicle + ' - ' + e.link.value
                    };
                }
            });
            deferred.resolve(result);
        }).error(function (data, status) {
            deferred.reject(status);
        });
        return deferred.promise;
    };

    obj.unpairOffline = function (serialNo) {
        var url = $rootScope.apiUrl + '/vehicle/' + serialNo + '/unlink/offline';
        return $http.post(url);;
    };

    obj.swapDVR = function (serialNo, DVRCurrent, DVRSelected, swapType) {
        var url = $rootScope.apiUrl + '/vehicle/' + serialNo + '/swap';
        return $http.post(url, {
            DVRCurrent: DVRCurrent,
            DVRSelected: DVRSelected,
            swapType: swapType
        });
    };

    obj.checkDVRVehicle = function (customerId, id, vehicleNum) {
        var deferred = $q.defer();
        var url = $rootScope.apiUrl + '/dvr/check/vehicle';
        url += '?customerId=' + customerId;
        url += '&id=' + id;
        url += '&vehicle=' + vehicleNum;

        $http.get(url)
            .success(function(json) {
                deferred.resolve(json);
            })
            .error(function (data, status) {
                deferred.reject({data: data, status: status});
            });

        return deferred.promise;
    };

    obj.checkVIN = function (vin) {
        var deferred = $q.defer();
        var url = $rootScope.apiUrl + '/dvr/check/vin';
        url += '?vin=' + vin;

        $http.get(url)
            .success(function(json) {
                deferred.resolve(json);
            })
            .error(function (data, status) {
                deferred.reject(status);
            });

        return deferred.promise;
    };

    obj.getCustomerSettings = function (id) {
        var deferred = $q.defer();
        var url = $rootScope.apiUrl + '/customer/' + id + '/settings';

        $http.get(url)
            .success(function(json) {
                deferred.resolve(json);
            })
            .error(function (data, status) {
                deferred.reject(status);
            });

        return deferred.promise;
    };

    return obj;
});

'use strict';

var module = angular.module('viAdminUi');

var iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
var isChrome = navigator.userAgent.indexOf('CriOS') != -1;
var STREAMAXFT = '3';

module.controller('ActivationCtrl',['$scope', '$location', '$window', 'mainFactory', 'WizardHandler', '$timeout', 'authFactory', 'activationFactory', 'dvrSerialNumberScannerService', 'vinScannerService', '$q', '$mdDialog', 'vinValidatorService', '$translate', '$filter', function ($scope, $location, $window, mainFactory, WizardHandler, $timeout, authFactory, activationFactory, dvrSerialNumberScannerService, vinScannerService, $q, $mdDialog, vinValidatorService, $translate, $filter) {
  $scope.snapshotSources = [];
  var SdCardStatus = {
    NO_CARD: {
      label: 'activation.dvr.sdCardStatus.noCard',
      cssClass: 'no-sd-card',
      svgIcon: 'sdcard-grey'
    },
    NOT_MOUNTED: {
      label: 'activation.dvr.sdCardStatus.notHealthy',
      cssClass: 'sd-not-mounted',
      svgIcon: 'sdcard-red'
    },
    HAS_CARD: {
      label: 'activation.dvr.sdCardStatus.healthy',
      cssClass: 'sd-card-ok',
      svgIcon: 'sdcard-green'
    },
  };

  var user = authFactory.getCurrentUser();
  if (user == null || user.role != 'installer') {
    //not authorized
    $location.path('/login');
    return;
  }
  $scope.user = user;
  if (user.dvrPairing) {
    $scope.dvrPairing = user.dvrPairing;
  }

  var ErrorMessage = function (message, error) {
    return {
      message: message,
      show: true,
      class: (error === true ? 'error' : '')
    };
  };

  var displayChormeIosToast = function() {
    if ( iOS && isChrome){
      $scope.showSimpleToast('activation.dvr.toast.ios', false);
      return true;
    }
    return false
  }

  $scope.selectedItemChange = function (item) {
    if (item) {
      $timeout($scope.getConfig, 300);
    }
  };

  $scope.checkSystemId = function (id) {
    return ($scope.user.systemId === id);
  };

  $scope.isM1NInstall = function () {
    return ($scope.dvr.provider === STREAMAXFT);
  }

  $scope.isAdplusInstall = function () {
    return ($scope.dvr.serialNo.startsWith('00D2'));
  }

  $scope.checkDVRPairMethod = function(method) {
    return ($scope.dvrPairing ? $scope.dvrPairing.method === method : false);
  }

  $scope.doTestCameras = function (source, trigger) {
    if (source == 'user') {
      $scope.showLoading = true;
      $scope.showSimpleToast('activation.dvr.toast.loadingCamera', true);
    }

    $scope.testCamerasPromises = [];
    $scope.textCamerasTimestamp = new Date().getTime();
    $scope.testCameras = false;

    return mainFactory.getCamerasSnap($scope.dvr.serialNo, $scope.dvr.customerId, $scope.dvr.machineType, trigger)
      .then(function(result) {
        $scope.snapshotSources = Object.values(result.data)
          .map(function(snapshot) {
            return snapshot.data ? snapshot.data : '/assets/images/camera-offline-icon.png';
          });
        $scope.testCameras = true;

        if (source == 'user') {
          $scope.showLoading = false;
        }
      })
      .catch(function() {
        if (source == 'user') {
          $scope.showLoading = true;
          $scope.showSimpleToast('activation.dvr.testCamera.toast.testFailed', false);
        }
      });
  };

  $scope.startDvrSerialBarcodeScanner = function(event) {
    if ( displayChormeIosToast() ){
      return;
    }
    dvrSerialNumberScannerService.show({
      dialog: {
        targetEvent: event
      }
    }).onDetected(function(result) {
      if (!result) {
        return;
      }

      $scope.search.value = result.serialNumber;
      $scope.getConfig();
      $scope.$apply();

      this.close();
    });
  };

  $scope.getConfig = function () {
    $scope.error = null;
    $scope.showLoading = true;
    $scope.dsnSet = false;
    $scope.cidDisabled = false;
    $scope.testCameras = false;
    $scope.channels = [];

    mainFactory.getDvrConfig($scope.search, $scope.user.role).then(function (dvrConfig) {
      $scope.swap = {
        dvr: null,
        newSerial: null,
        showField: false,
        isVisible: true //($scope.user.user != '57')
      };

      //check pair method and update accordingly to DVR
      if (!$scope.dvrPairing && (dvrConfig.dvrIdentification.link && dvrConfig.dvrIdentification.link.type )) {
        $scope.dvrPairing = { method: dvrConfig.dvrIdentification.link.type }
      } else if ($scope.dvrPairing && $scope.user.permission === 'admin') {
        //dvr pair method will be replaced by CID settings
        var pairMethod = $scope.dvrPairing.method ? $scope.dvrPairing.method: 'dsn';
        $scope.dvrPairing = {
          method: (dvrConfig.dvrIdentification.link ? dvrConfig.dvrIdentification.link.type : pairMethod)
        }
      }

      var machineType = dvrConfig.dvrIdentification.machineType;
      $scope.dvr = {
        serialNo: dvrConfig.dvrIdentification.serialNo,
        customerId: dvrConfig.dvrIdentification.cid === 0 ? '' : dvrConfig.dvrIdentification.cid,
        vehicleNum: dvrConfig.dvrIdentification.vehicleNum,
        triggerType: 'efetch',
        machineType: machineType ? machineType : 0,
        provider: dvrConfig.dvrIdentification.provider,
      };
      $scope.customerName = dvrConfig.dvrIdentification.customerName || "";
      if ($scope.checkDVRPairMethod('vin')) {
        $scope.dvr.vin = dvrConfig.dvrIdentification.link ? dvrConfig.dvrIdentification.link.value : null;
      } else {
        $scope.dvr.vin = (dvrConfig.vehicle && dvrConfig.vehicle.vin) ? dvrConfig.vehicle.vin : null;
        $scope.dvr.dsn =  dvrConfig.dvrIdentification.link ? dvrConfig.dvrIdentification.link.value : null;
      }

      if (dvrConfig.dvrIdentification.triggerType != null && ($scope.dvr.dsn != null && $scope.dvr.vehicleNum != null)) {
        $scope.dvr.triggerType = dvrConfig.dvrIdentification.triggerType;
      }

      if (dvrConfig.recordingSettings) {
        $scope.channels = [];
        // TODO: WE NEED TO CHANGE HOW WE MOUNT THESE DATAS TO UI
        // When Machine Type === 1 (2cam), Indexes 0(front) and 1(rear)
        $scope.channels[0] = dvrConfig.recordingSettings.recEnableArray[0] == 1;
        $scope.channels[1] = dvrConfig.recordingSettings.recEnableArray[1] == 1;
        // When Machine Type === 0 or null (4cam), Indexes 0(front), 1(driver), 2(rear), 3(passenger)
        $scope.channels[2] = dvrConfig.recordingSettings.recEnableArray[2] == 1;
        $scope.channels[3] = dvrConfig.recordingSettings.recEnableArray[3] == 1;
      }

      if (
        ($scope.checkDVRPairMethod('dsn') && $scope.dvr.dsn != null) ||
        ($scope.checkDVRPairMethod('vin') && $scope.dvr.vin != null)
      ) {
        $scope.errorStep3 = new ErrorMessage($scope.messages.dvrLinked);
        $scope.dsnSet = true;
      } else if ($scope.user.permission != 'admin') {
        //if permission is installer, block customerId and fill with user name.
        $scope.cidDisabled = true;
        $scope.dvr.customerId = $scope.user.customerId;
        $scope.customerName = $scope.user.customerName;
      }

      if ($scope.dvr.customerId) {
        setTimeout(function() {
          $scope.forms.bindVehicleForm.customerId.$setValidity('md-maxlength', true);
        }, 500);
      }

      $scope.offlineMode = false;
      if (dvrConfig._status && dvrConfig._status == 'offline') {
        $scope.offlineMode = true;
        $scope.errorStep3.show = false;
      }

      $timeout(function () {
        WizardHandler.wizard().next();
        if (!$scope.offlineMode) {
          $scope.testDvr(false);
        }
      },100);
      $scope.showLoading = false;
    }, function(err) {
      $scope.showLoading = false;
      $scope.errorStep1 = new ErrorMessage($scope.messages.dvrNotFound, true);
    });
  };

  $scope.testDvr = function (shouldTrigger) {
    $scope.closeCameraPreview();
    $scope.showSimpleToast('activation.dvr.testDvr.toast.validating', true);
    $scope.showLoading = true;
    $q.all([
      $scope.doTestCameras(null, shouldTrigger),
      $scope.validateSDCard()
    ]).then(function() {
      $scope.showLoading = false;
    }, function (err) {
      $scope.showSimpleToast('activation.dvr.testDvr.toast.failed', false);
      $scope.showLoading = false;
    });
  }

  $scope.querySearch = function (text) {
    return activationFactory.searchAutocomplete(text, $scope.search.mode);
  };

  $scope.goNext = function () {
    //workaround to fix button triggering the same event twice.
    if (WizardHandler.wizard().currentStep().title == "Test DVR") {
      WizardHandler.wizard().next();
    }
  };

  $scope.doPostData = function (link) {
    var obj = {
      dvrIdentification : $scope.dvr,
      dvrPairing: $scope.dvrPairing,
      recordingSettings: {
        recEnableArray: [
          $scope.channels[0] ? 1 : 0,
          $scope.channels[1] ? 1 : 0,
          $scope.channels[2] ? 1 : 0,
          $scope.channels[3] ? 1 : 0
        ]
      }
    };
    obj.dvrIdentification.link = link;
    if ($scope.offlineMode) {
      obj._status == 'offline';
    } else if (link !== undefined && link !== null) {
      obj.dvrIdentification.factoryEn = !link;
    }
    $scope.showLoading = true;

    return mainFactory.postDvrConfig($scope.search, obj);
  };

  $scope.postData = function () {
    $scope.checkVehicleNum(function () {
      $scope.doPostData().then(function() {
        $scope.showLoading = false;
        $scope.showSimpleToast('activation.dvr.toast.update.success', true);
      }, function error(data, status) {
        $scope.showLoading = false;
        if (data && data.meta && data.meta.error && Array.isArray(data.meta.error.errors) && data.meta.error.errors.length > 0) {
          $scope.showSimpleToast(data.meta.error.errors.join('\n'), false, 10000);
        } else {
          //generic error
          $scope.showSimpleToast('activation.dvr.toast.update.failed', false);
        }
      });
    });
  };

  $scope.confirmPost = function (message) {
    var confirm = $scope.$mdDialog.confirm({
      parent: (angular.element(document.body)),
      title: $translate.instant('label.warning'),
      content: $translate.instant(message),
      ok: $translate.instant('label.ok'),
      cancel: $translate.instant('label.cancel')
    });
    return $scope.$mdDialog.show(confirm);
  };

  $scope.checkVehicleNum = function (callback) {
    if ($scope.dvr.vehicleNum.toString().toLowerCase().trim() == 's188') {
      $scope.confirmPost($scope.messages.dvrConfirmVehicleNum).then(function () {
        callback();
      });
    }else {
      callback();
    }
  };

  //true to link, false to unlink
  $scope.link = function (type, swap, ev) {
    $scope.linkType = type;

    var execLink = function(swap) {
      $scope.checkVehicleNum(function() {
        $scope.showSimpleToast('activation.dvr.toast.link.validating.vin', true, 350);
        $scope.validVIN($scope.dvr.vin, true, function(){
          $scope.showSimpleToast('activation.dvr.toast.link.pairing.dvr', true);

          $scope.doPostData(true).then($scope.linkSuccess, $scope.linkError);
        });
      });
    };

    var confirm = $mdDialog.alert()
      .title('')
      .content($translate.instant('activation.dvr.modal.content.alreadyPaired'))
      .targetEvent(ev)
      .ok($translate.instant('label.ok'));

    if ($scope.linkType) {
      if (swap && !$scope.dsnSet && $scope.swap.isVisible) {
        $scope.validVIN($scope.dvr.vin, true, function(){
          var id = $scope.dvrPairing.method === 'dsn' ? $scope.dvr.dsn : $scope.dvr.vin;
          activationFactory.checkDVRVehicle($scope.dvr.customerId, id, $scope.dvr.vehicleNum).then(function (res) {
            var data = res.hits.hits;
            var DVRdiffCID = data.filter(function(item){
              var customerId = item._source.customerId || item._source.cid;
              return (customerId != $scope.dvr.customerId);
            });
            if (DVRdiffCID.length > 0) {
              if ($scope.dvrPairing.method === 'dsn') {
                $scope.showSimpleToast('activation.dvr.toast.dsn.alreadyPaired', false);
              } else {
                $scope.showSimpleToast('activation.dvr.toast.vin.alreadyPaired', false);
              }
              return;
            }
            if (data.length >= 2){
              if ($scope.dvrPairing.method === 'dsn') {
                $scope.showSimpleToast('activation.dvr.toast.dsn.notMatch', false);
              } else {
                $scope.showSimpleToast('activation.dvr.toast.vin.notMatch', false);
              }
            } else if (data.length == 1){
              $scope.swap.dvr = data[0]._source;
              if (data[0].inner_hits) {
                var inner_hits = data[0].inner_hits;
                if (inner_hits.config.hits.total > 0) {
                  var hit = inner_hits.config.hits.hits[0];
                  if (hit._source.dvrIdentification) {
                    $scope.swap.dvr.machineType = hit._source.dvrIdentification.machineType
                  }
                }
              }
              $mdDialog.show(confirm).then(function() {
                // Ok do nothing until swap functionality is working again
              });
            } else {
              execLink();
            }
          }, function (err) {
            if (err.status === 401) {
              $scope.showSimpleToast('activation.dvr.toast.vin.alreadyPaired', false);
            } else {
              $scope.showSimpleToast('activation.dvr.toast.check.failed', false);
            }
          });
        });
      } else {
        execLink(false);
      }
    } else {
      $scope.showSimpleToast('activation.dvr.toast.unPairing', true);
      $scope.doPostData(false).then($scope.linkSuccess, $scope.linkError);
    }
  };

  $scope.swapDVR = function (swapType) {

    var dvrCurrent = null, dvrSelected = null;

    dvrCurrent = {
      serialNo: $scope.dvr.serialNo,
      dvrIdentification : $scope.dvr,
      dvrPairing: $scope.dvrPairing,
    };
    if ($scope.offlineMode){
      dvrCurrent.offline = $scope.offlineMode;
    }
    dvrSelected = {
      serialNo: $scope.swap.dvr.serialNo,
      dvrIdentification : $scope.swap.dvr,
      dvrPairing: $scope.dvrPairing,
      recordingSettings: {
        recEnableArray: [
          $scope.channels[0] ? 1 : 0,
          $scope.channels[1] ? 1 : 0,
          $scope.channels[2] ? 1 : 0,
          $scope.channels[3] ? 1 : 0
        ]
      }
    };

    if (swapType == $scope.swapType.INPUTNEW) {
      dvrSelected.dvrIdentification.triggerType = dvrCurrent.dvrIdentification.triggerType;
    } else if (swapType == $scope.swapType.CONFLICTDSNVEHICLE) {
      dvrCurrent.dvrIdentification.triggerType = dvrSelected.dvrIdentification.triggerType;
    }

    if(dvrSelected.serialNo == dvrCurrent.serialNo){
      $scope.showSimpleToast('activation.dvr.toast.error.swap', false);
      $scope.showOverLay = false;
      return;
    }

    $scope.showOverLay = true;
    $scope.showSimpleToast('activation.dvr.toast.swapping', true);

    activationFactory.swapDVR($scope.dvr.serialNo, dvrCurrent, dvrSelected, swapType).then(function () {
      $scope.reset();
      $scope.showSimpleToast('activation.dvr.toast.swap.success', true);
      $scope.showOverLay = false;
    }, function (err) {
      $scope.showSimpleToast('activation.dvr.toast.update.failed', false);
      $scope.showOverLay = false;
    });
  };

  $scope.checkNewDVR = function() {
    if (!$scope.swap.showField) {
      $scope.showSimpleToast('activation.dvr.toast.link.validating.vin', true, 350);
      $scope.validVIN($scope.dvr.vin, true, function() {
        $scope.swap.showField = true;
      });
      return;
    }

    if ($scope.swap.newSerial == null) {
      $scope.newSerialRequired = true;
      return;
    }

    var search = {
      mode: 'serial',
      label: 'serial',
      value: $scope.swap.newSerial
    };

    if ($scope.swap.newSerial.length <= 0) {
      $scope.newSerialRequired = true;
    } else {
      $scope.newSerialRequired = false;
      $scope.showOverLay = true;
      $scope.showSimpleToast('activation.dvr.toast.validating.newDvr', true);

      mainFactory.getDvrConfig(search, $scope.user.role).then(function (dvrConfig) {
        $scope.showOverLay = false;

        $scope.swap.dvr = {
          serialNo: dvrConfig.dvrIdentification.serialNo,
          customerId: (dvrConfig.dvrIdentification.cid == 0 ? null : dvrConfig.dvrIdentification.cid),
          dsn: dvrConfig.dvrIdentification.dsn,
          vehicleNum: dvrConfig.dvrIdentification.vehicleNum,
          machineType: dvrConfig.dvrIdentification.machineType
        };


        if ($scope.user.role === 'installer' && $scope.swap.dvr.customerId && $scope.swap.dvr.customerId != $scope.dvr.customerId) {
          $scope.showSimpleToast('activation.dvr.toast.swap.differentCID', false);
          return;
        }

        if (dvrConfig._status && dvrConfig._status == 'offline') {
          $scope.showSimpleToast('activation.dvr.toast.swap.deviceOffline', false);
          return;
        }
        if ($scope.swap.dvr.dsn != null) {
          $scope.showSimpleToast('activation.dvr.toast.swap.alreadyPaired', false);
          return;
        }

        $scope.swapDVR($scope.swapType.INPUTNEW);

      }, function(err) {
        $scope.showOverLay = false;
        $scope.showSimpleToast('activation.dvr.toast.swap.deviceOffline', false);
        $scope.swap.dvr = null;
        return;
      });

    }
  };

  $scope.unpairOffline = function () {
    activationFactory.unpairOffline($scope.dvr.serialNo).then(function () {
      $scope.reset();
      $scope.showSimpleToast('activation.dvr.toast.unPair.success', true);
    }, function () {
      $scope.showSimpleToast('activation.dvr.toast.update.failed', false);
    });
  }

  $scope.linkError = function (data, status) {
    $scope.showLoading = false;
    if (data && data.meta && data.meta.error && Array.isArray(data.meta.error.errors) && data.meta.error.errors.length > 0) {
      $scope.showSimpleToast(data.meta.error.errors.join('\n'), false, 10000);
    } else {
      //generic error
      $scope.showSimpleToast('activation.dvr.toast.update.failed', false);
    }
  }

  $scope.linkSuccess = function () {
    $scope.showLoading = false;
    if ($scope.linkType) {
      $scope.dsnSet = true;
      WizardHandler.wizard().next();
      WizardHandler.wizard().finish();
    } else {
      WizardHandler.wizard().reset();
      $scope.dvr.dsn = null;
      $scope.dvr.vin = null;
      $scope.dvr.customerId = null;
      $scope.dvr.vehicleNum = null;
      $scope.dvr.machineType = 0;
      $scope.dsnSet = false;
      $scope.showSimpleToast('activation.dvr.toast.unPair.success', true);
    }
  };

  $scope.setSearchMode = function (mode) {
    $scope.search.mode = mode;
    $scope.search.label = $scope.getSearchLabel($scope.search.mode);
  }

  $scope.getSearchLabel = function (mode) {
    if (mode == $scope.modes.serial) {
      return 'activation.dvr.mode.serial';
    } else if (mode == $scope.modes.vehicle) {
      return 'activation.dvr.mode.vehicleNumber';
    } else if (mode == $scope.modes.dsn) {
      return 'activation.dvr.mode.dsn';
    }
  }

  $scope.reset = function () {
    $scope.dvr = {
      serialNo: null,
      vin: null,
      dsn: null,
      customerId: null,
      triggerType: null,
      vehicleNum: null,
      machineType: 0,
      offlineMode: false,
      provider: null
    };

    $scope.swap = {
      dvr: null,
      newSerial: null,
      showField: false,
      isVisible: true //TODO: CHECK ADMIN/INSTALLER USERS | OLD CODE: ($scope.user.user != '57')
    };

    $scope.dsnSet = false;
    $scope.errorStep1 = null;
    $scope.errorStep3 = null;
    $scope.testCameras = false;

    $scope.form = {
      VINValid: true,
      VINExists: false,
      VINRequired: true
    };

    $scope.sdCardsStatus = {
      ok: false,
      errors: {
        noCardFound: false,
        hasCardNotMounted: false,
        doorOpen: false,
        offline: false
      },
      sdCards: [
        {id: "1", status: SdCardStatus.NO_CARD},
        {id: "2", status: SdCardStatus.NO_CARD},
        {id: "3", status: SdCardStatus.NO_CARD},
        {id: "4", status: SdCardStatus.NO_CARD}
      ]
    };
    $scope.closeCameraPreview()
    $scope.search = {
      mode:  $scope.modes.serial,
      value: '',
      label: $scope.getSearchLabel($scope.modes.serial),
      item: null
    };
    if (WizardHandler.wizard() != null) {
      WizardHandler.wizard().reset();
    }
  };

  $scope.openCameraPreview = function (label, channel) {
    $scope.cameraPreviewLabel = $translate.instant(label);
    $scope.showCameraPreviewSrc = $scope.snapshotSources[channel];
    $scope.showCameraPreview = true;
  };
  $scope.closeCameraPreview = function () {
    $scope.cameraPreviewLabel = null;
    $scope.showCameraPreviewUrl = null;
    $scope.showCameraPreview = false;
  }

  $scope.validateSDCard = function () {
    var deferred = $q.defer();

    $scope.showLoading = true;
    $scope.showSimpleToast('activation.dvr.toast.sdCard.validating', true);

    $scope.sdCardsStatus.ok = false;
    $scope.sdCardsStatus.errors = {};
    $scope.sdCardsStatus.sdCards.forEach(function(sdCard) {
      sdCard.status = SdCardStatus.NO_CARD;
    });

		mainFactory.getSDCardState($scope.dvr.serialNo, 'remote', 'update').then(function(result) {
			if (result.isOffline) {
				$scope.sdCardsStatus.errors.offline = true;
			} else {
				if (result.isDoorOpen) {
					$scope.sdCardsStatus.errors.doorOpen = true;
				} else {
					$scope.sdCardsStatus.errors.noCardFound = true;

					$scope.sdCardsStatus.sdCards.forEach(function(sdCard, index) {
						var isCardInserted = (result.storageExist && result.storageExist[index]);

						if (!isCardInserted) {
							return;
						}

						delete $scope.sdCardsStatus.errors.noCardFound;

						var isCardMounted = (result.storageMounted && result.storageMounted[index]);

						if (!isCardMounted) {
							sdCard.status = SdCardStatus.NOT_MOUNTED;
							$scope.sdCardsStatus.errors.hasCardNotMounted = true;
							return;
						}

						sdCard.status = SdCardStatus.HAS_CARD;
					});
				}
			}

      if (Object.keys($scope.sdCardsStatus.errors).length == 0) {
        $scope.sdCardsStatus.ok = true;
      }

      $scope.showLoading = false;
      deferred.resolve();
    }, function error(status) {
      $scope.sdCardsStatus.ok = false;
      $scope.sdCardsStatus.errors.offline = true;
      $scope.showLoading = false;
      $scope.showSimpleToast('activation.dvr.toast.sdCard.check.failed', false);
      deferred.resolve();
    });
    return deferred.promise;
  }

  $scope.showConfirmAction = function (ev, type, dvr) {
    if(angular.element(document).find('md-dialog').length > 0) {
      return false;
    }

    $window.scrollTo(0,0);

    var confirm = $mdDialog.confirm()
        .parent(angular.element(document.body))
        .title($translate.instant('activation.dvr.dialog.unPair.title'))
        .content($translate.instant('activation.dvr.dialog.unPair.content'))
        .ok($filter('uppercase')($translate.instant('label.yes')))
        .cancel($filter('uppercase')($translate.instant('label.no')))
        .hasBackdrop(true)
        .targetEvent(ev);

    if (type === 'UPDATE'){
        $scope.showSimpleToast('activation.dvr.toast.link.validating.vin', true, 350);
        $scope.validVIN($scope.dvr.vin, true, function() {
          confirm.content($translate.instant('activation.dvr.dialog.confirm.configUpdate')).title($translate.instant('activation.dvr.dialog.update.title'));
          $mdDialog.show(confirm).then(function() {
            $scope.showSimpleToast('activation.dvr.toast.update.progress', true);
            $scope.postData('dvrIdentification', dvr);
          }, function() { /* NO */ });
      });
    } else if (type === 'UNPAIRONLINE') {
      $mdDialog.show(confirm).then(function() {
        $scope.link(false);
      }, function() { /* NO */ });
    } else if (type === 'UNPAIROFFLINE') {
      $mdDialog.show(confirm).then(function() {
        $scope.unpairOffline();
      }, function() { /* NO */ });
    }

    return false;
  };

  $scope.startVinBarcodeScanner = function(event) {
    if ( displayChormeIosToast()){
      return;
    }
    vinScannerService.show({
      dialog: {
        targetEvent: event
      }
    }).onDetected(function(result) {
      if (!result) {
        return;
      }

      $scope.dvr.vin = result.vin;
      $scope.validVIN(result.vin);
      $scope.$apply();

      this.close();
    });
  };

  $scope.validVIN = function(vin, errorToaster, callback) {
    $scope.form.VINRequired = $scope.checkDVRPairMethod('vin');

    if (vin && vin.length > 0) {
      if ($scope.user.vinValidation === false) {
        $scope.form.VINRequired = false;
        $scope.form.VINValid = true;
        $scope.form.VINExists = false;

        if (callback) {
          callback();
        }

        return true;
      }

      $scope.form.VINRequired = false;
      var result = vinValidatorService.validate(vin);
      $scope.form.VINValid = result.valid;
      $scope.form.VINExists = false;

      if (result.valid && (($scope.checkDVRPairMethod('dsn') && $scope.dvr.dsn))) {
        activationFactory.checkVIN(vin).then(function (res) {
          if (res.length > 0) {
            var dsn = res[0]._source.dsn;
            $scope.form.VINExists = $scope.dvr.dsn.toUpperCase() !== dsn.toUpperCase();
          }
          if (!$scope.formIsValid()) {
            $scope.showSimpleToast('activation.dvr.form.bindVehicle.vin.message.alreadtExists', false, 450);
          }
          if (callback && $scope.formIsValid()) { callback(); return; }
          return $scope.formIsValid();
        }, function(err) {
          var data = err;
          $scope.form.VINValid = false;
          return $scope.formIsValid();
        });
      } else if ($scope.checkDVRPairMethod('vin')) {
        if (callback && $scope.formIsValid()) {
          callback();
          return;
        }
        return $scope.formIsValid();
      } else {
        if (errorToaster && !result.valid) {
          $scope.showSimpleToast('activation.dvr.form.bindVehicle.vin.message.required', false, 450);
        }
        return $scope.formIsValid();
      }
    } else {
      $scope.form.VINValid = true;
      $scope.form.VINExists = false;

      if (callback && $scope.formIsValid()) { callback(); return; }
      return $scope.formIsValid();
    }
  };

  $scope.checkCustomerSettings = function (customerId) {
    activationFactory.getCustomerSettings(customerId).then(function(settings) {
      if (settings ) {
        if(settings.customerName){
          $scope.customerName = settings.customerName;
        }
        if(settings.dvrPairing){
            $scope.dvrPairing = settings.dvrPairing;
            if ($scope.checkDVRPairMethod('vin')) {
              $scope.dvr.dsn = undefined;
            }
          } else {
            $scope.dvrPairing = { method: 'dsn' };
          }
        }
    });
  }


  $scope.confirmActiveChannel = function (channelNumber){
    var valueBeforeSwitch = $scope.channels[channelNumber];
    if (!valueBeforeSwitch) return null;

    var confirm = $scope.$mdDialog.confirm({
      parent: (angular.element(document.body)),
      title: $translate.instant('activation.dvr.dialog.billing.title'),
      content: $translate.instant('activation.dvr.dialog.billing.content'),
      ok: $filter('uppercase')($translate.instant('label.activate')),
      cancel: $filter('uppercase')($translate.instant('label.cancel'))
    });
    $scope.$mdDialog.show(confirm).catch(function() {
      $scope.channels[channelNumber] = false;
    });
  };

  $scope.formIsValid = function () {
    return ($scope.form.VINValid && !$scope.form.VINExists && !$scope.form.VINRequired);
  };

  // init
  $scope.messages = {
    dvrLinked: 'activation.dvr.form.settings.error.alreadyLinked',
    dvrNotFound: 'activation.dvr.form.settings.error.notFound',
    dvrConfirmVehicleNum: 'activation.dvr.form.settings.error.confirmVehicleNum'
  };
  $scope.modes = {
    ip: 'ip',
    dsn: 'dsn',
    serial: 'serial',
    vehicle: 'vehicle'
  };

  $scope.swapType = {
    CONFLICTDSNVEHICLE: 1,
    INPUTNEW: 2
  };

  $scope.form = {
    VINValid: true,
    VINExists: false,
    VINRequired: true
  };

  $scope.forms = {};
  $scope.error = {};
  $scope.reset();
}])

angular.module('myApp.config', [])
.constant('apiUrl', "https://dvr-api.pnetvi.com");

angular.module("viAdminUi").run(["$templateCache", function($templateCache) {$templateCache.put("app/activation/activation.html","<header ng-include=\"\'app/components/navbar/navbar.html\'\"></header><md-divider></md-divider><div><wizard hide-indicators=\"true\"><wz-step wz-title=\"Search\"><div layout=\"row\"><div flex=\"\"></div><div layout=\"column\" class=\"wizard-step-body\"><div class=\"searchSection\" layout-padding=\"\"><div flex=\"\" layout=\"row\"><form name=\"dvrSettingsForm\" class=\"dvrSettingsForm\" autocomplete=\"off\"><div layout=\"row\" layout-align=\"start center\" flex=\"\"><div ng-if=\"search.mode == modes.vehicle\" class=\"searchVehicleCont\"><md-autocomplete class=\"dvr-autocomplete serialfield\" md-selected-item=\"search.item\" md-search-text=\"search.value\" md-selected-item-change=\"selectedItemChange(item)\" md-items=\"item in querySearch(search.value)\" md-search-text-change=\"searchTextChange(search.value)\" md-item-text=\"item.id\" md-min-length=\"3\" md-no-cache=\"true\" placeholder=\"{{search.label | translate}}\"><md-item-template><span md-highlight-text=\"ctrl.searchText\" md-highlight-flags=\"^i\">{{item.display}}</span></md-item-template><md-not-found><div class=\"errorMessage dvr-notfound-msg\" ng-if=\"search.mode == modes.vehicle\">{{\'activation.dvr.form.settings.warning.vehicleNotFound\' | translate}}</div><div class=\"errorMessage dvr-notfound-msg\" ng-if=\"search.mode == modes.serial\">{{\'activation.dvr.form.settings.warning.serialNotFound\' | translate}}</div></md-not-found></md-autocomplete></div><div ng-if=\"search.mode == modes.serial\"><md-input-container><label>{{\'activation.dvr.form.settings.label.serial\' | translate}}</label> <input ng-model=\"search.value\" autocomplete=\"off\" class=\"serialfield\"></md-input-container></div><md-button ng-show=\"search.mode == modes.serial\" type=\"button\" class=\"md-raised md-default md-button md-xsmall\" ng-click=\"startDvrSerialBarcodeScanner($event)\" ng-disabled=\"search.mode!=modes.serial || showLoading\"><i class=\"fa fa-barcode\"></i></md-button><md-button type=\"submit\" class=\"md-raised md-primary md-button md-xsmall\" ng-click=\"getConfig()\" ng-disabled=\"search.value.trim().length == 0 || showLoading\"><i class=\"fa fa-search\"></i></md-button></div><div layout=\"column\" layout-align=\"center\" flex=\"\"><label class=\"md-caption margin-top-50\">{{\'activation.dvr.form.settings.label.search\' | translate}}</label><selection layout=\"row\" layout-align=\"start center\"><md-button class=\"btgroup left selected lesspadding\" ng-class=\"(search.mode==modes.serial ? \'selected\': \'\')\" ng-click=\"setSearchMode(modes.serial)\">{{\'activation.dvr.form.settings.label.serial\' | translate}}</md-button><md-button class=\"btgroup right lesspadding\" ng-class=\"(search.mode==modes.vehicle ? \'selected\': \'\')\" ng-click=\"setSearchMode(modes.vehicle)\">{{\'activation.dvr.form.settings.label.vehicleNumber\' | translate}}</md-button></selection></div></form></div></div><div layout=\"row\" class=\"mainLoading\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"showLoading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-card ng-show=\"errorStep1.show && showLoading == false\" layout-padding=\"\"><p ng-class=\"errorStep1.class\">{{errorStep1.message | translate}}</p></md-card></div><div flex=\"\"></div></div></wz-step><wz-step wz-title=\"Test DVR\" wz-disabled=\"{{offlineMode}}\"><div layout=\"row\"><div flex=\"\"></div><div layout=\"column\" class=\"wizard-step-body\"><div class=\"camerasPreview\"><div class=\"action-buttons\"><md-button class=\"md-raised md-default md-button\" ng-click=\"reset(true)\" analytics-on=\"click\" analytics-event=\"Previous button\" analytics-properties=\"{category:\'Installation\', label:\'Test cameras step\'}\">{{\'label.prev\' | translate | uppercase}}</md-button><md-button class=\"md-raised md-default md-button\" ng-click=\"goNext()\" ng-disabled=\"!sdCardsStatus.ok\" analytics-on=\"click\" analytics-event=\"Next button\" analytics-properties=\"{category:\'Installation\', label:\'Test cameras step\'}\">{{\'label.next\' | translate | uppercase}}</md-button></div><div class=\"action-buttons\"><md-button class=\"md-raised md-primary md-button test-dvr-bt\" ng-click=\"testDvr(true)\" analytics-on=\"click\" analytics-event=\"Test cameras button\" analytics-properties=\"{category:\'Installation\', label:\'Test cameras step\'}\">{{\'activation.dvr.camerasPreview.label.testDvr\' | translate | uppercase}} <i class=\"fa fa-video-camera\"></i></md-button></div><div class=\"cameras camera-bigview\" ng-show=\"showCameraPreview\"><label class=\"snapshotLabel\">{{cameraPreviewLabel}}</label> <i class=\"fa fa-times close-bigview\" ng-click=\"closeCameraPreview()\"></i><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\"><img class=\"snapshotAspectRatio\" id=\"c-preview\" ng-if=\"showCameraPreview\" ng-src=\"{{showCameraPreviewSrc}}\"></div></div><div class=\"cameras\" ng-show=\"!showCameraPreview\"><label class=\"snapshotLabel\">{{\'activation.dvr.camerasPreview.forwardFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 1)</label><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\" ng-click=\"openCameraPreview(\'activation.dvr.camerasPreview.forwardFacingCamera\', 0)\"><img class=\"snapshotAspectRatio\" id=\"c-0\" ng-if=\"testCameras\" ng-src=\"{{snapshotSources.length > 0 && snapshotSources[0]}}\"></div></div><div class=\"cameras\" ng-if=\"dvr.machineType === 1 || dvr.machineType === 4\" ng-show=\"!showCameraPreview\"><label class=\"snapshotLabel\">{{dvr.machineType === 4 ? \'activation.dvr.adplus2.camerasPreview.inCabinCamera\' : \'activation.dvr.camerasPreview.rearFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 2)</label><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\" ng-click=\"openCameraPreview(dvr.machineType === 4 ? \'activation.dvr.adplus2.camerasPreview.inCabinCamera\' : \'activation.dvr.camerasPreview.rearFacingCamera\', 1)\"><img class=\"snapshotAspectRatio\" id=\"c-1\" ng-if=\"testCameras\" ng-src=\"{{snapshotSources.length >= 2 && snapshotSources[1]}}\"></div></div><div class=\"cameras\" ng-if=\"dvr.machineType !== 1 && dvr.machineType !== 4\" ng-show=\"!showCameraPreview\"><label class=\"snapshotLabel\">{{\'activation.dvr.camerasPreview.rearFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 3)</label><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\" ng-click=\"openCameraPreview(\'activation.dvr.camerasPreview.rearFacingCamera\', 2)\"><img class=\"snapshotAspectRatio\" id=\"c-2\" ng-if=\"testCameras\" ng-src=\"{{snapshotSources.length >= 3 && snapshotSources[2]}}\"></div></div><div class=\"cameras\" ng-if=\"dvr.machineType !== 1\" ng-show=\"!showCameraPreview\"><label class=\"snapshotLabel\">{{\'activation.dvr.camerasPreview.driverSideCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 4)</label><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\" ng-click=\"openCameraPreview(\'activation.dvr.camerasPreview.driverSideCamera\', 3)\"><img class=\"snapshotAspectRatio\" id=\"c-3\" ng-if=\"testCameras\" ng-src=\"{{snapshotSources.length >= 4 && snapshotSources[3]}}\"></div></div><div class=\"cameras\" ng-if=\"dvr.machineType === 4\" ng-show=\"!showCameraPreview\"><label class=\"snapshotLabel\">{{\'activation.dvr.camerasPreview.passengerSideCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 3)</label><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\" ng-click=\"openCameraPreview(\'activation.dvr.camerasPreview.passengerSideCamera\', 2)\"><img class=\"snapshotAspectRatio\" id=\"c-2\" imageonload=\"\" ng-if=\"testCameras\" ng-src=\"{{snapshotSources.length >= 3 && snapshotSources[2]}}\"></div></div><div class=\"cameras\" ng-if=\"dvr.machineType !== 1 && dvr.machineType !== 4\" ng-show=\"!showCameraPreview\"><label class=\"snapshotLabel\">{{\'activation.dvr.camerasPreview.passengerSideCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 2)</label><div class=\"cameraImage\" ng-style=\"(testCameras && {\'background\':\'transparent\'})\" ng-click=\"openCameraPreview(\'activation.dvr.camerasPreview.passengerSideCamera\', 1)\"><img class=\"snapshotAspectRatio\" id=\"c-1\" imageonload=\"\" ng-if=\"testCameras\" ng-src=\"{{snapshotSources.length >= 2 && snapshotSources[1]}}\"></div></div></div><div class=\"\" layout=\"row\"><table class=\"sdcard-table\"><tbody><tr><td class=\"title\">{{\'activation.dvr.label.sdCards\' | translate}}</td></tr><tr><td><md-content class=\"validate-msg\" ng-show=\"!showLoading\"><div class=\"md-chips\"><div class=\"md-chip md-default-theme sdcard-chip-cont {{sdCard.status.cssClass}}\" ng-repeat=\"sdCard in sdCardsStatus.sdCards\"><div class=\"md-chip-content\"><img src=\"/images/{{sdCard.status.svgIcon}}.svg\" class=\"sdcard-sdicon\"> {{sdCard.id}} - {{sdCard.status.label | translate}}</div></div></div><md-list flex=\"\"><md-list-item class=\"md-4-line\" ng-show=\"sdCardsStatus.errors.noCardFound\"><i class=\"fa fa-exclamation-triangle\"></i>{{\'activation.dvr.sdCardStatus.configure.errors.noCardFound\' | translate}}</md-list-item><md-list-item class=\"md-4-line\" ng-show=\"sdCardsStatus.errors.hasCardNotMounted\"><i class=\"fa fa-exclamation-triangle\"></i> {{\'activation.dvr.sdCardStatus.configure.errors.hasCardNotMounted\' | translate}}</md-list-item><md-list-item class=\"md-4-line\" ng-show=\"sdCardsStatus.errors.doorOpen\"><i class=\"fa fa-exclamation-triangle\"></i>{{\'activation.dvr.sdCardStatus.configure.errors.doorOpen\' | translate}}</md-list-item><md-list-item class=\"md-4-line\" ng-show=\"sdCardsStatus.errors.offline\"><i class=\"fa fa-exclamation-triangle\"></i>{{\'activation.dvr.sdCardStatus.configure.errors.offline\' | translate}}</md-list-item><md-list-item class=\"md-4-line\" ng-show=\"sdCardsStatus.ok\"><i class=\"fa fa-check-circle\"></i>{{\'activation.dvr.sdCardStatus.configure.success\' | translate}}</md-list-item></md-list></md-content></td></tr></tbody></table></div><div layout=\"row\" class=\"mainLoading\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"showLoading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div></div><div flex=\"\"></div></div></wz-step><wz-step wz-title=\"Configure\"><div layout=\"row\"><div flex=\"\"></div><div layout=\"column\" class=\"wizard-step-body\"><div class=\"sg\" ng-show=\"errorStep3.show && showLoading == false\"><md-card layout-padding=\"\"><p ng-class=\"errorStep3.class\">{{errorStep3.message | translate}}</p></md-card><md-button class=\"md-raised md-default md-button\" wz-previous=\"\" style=\"min-width: 60px;\" analytics-on=\"click\" analytics-event=\"Previous button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'label.prev\' | translate | uppercase}}</md-button><md-button class=\"md-raised md-default md-button\" ng-click=\"reset(true)\" analytics-on=\"click\" analytics-event=\"Search again button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'activation.dvr.configure.label.searchAgain\' | translate}}</md-button><md-button class=\"md-raised md-primary md-button\" ng-click=\"errorStep3.show = false\" analytics-on=\"click\" analytics-event=\"DVR options button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'activation.dvr.configure.label.dvrOptions\' | translate}}</md-button></div><div layout=\"row\" class=\"mainLoading\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"showLoading || showOverLay\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><div class=\"bindVehicleForm\" ng-show=\"!showLoading && !errorStep3.show\"><form name=\"forms.bindVehicleForm\" autocomplete=\"off\"><md-input-container layout-fill=\"\" class=\"inputContainerSmall cid-field\"><label>{{\'activation.dvr.form.bindVehicle.label.cid\' | translate}}</label> <input autocomplete=\"off\" name=\"customerId\" required=\"\" ng-model=\"dvr.customerId\" ng-blur=\"checkCustomerSettings(dvr.customerId);\" ng-disabled=\"dsnSet || cidDisabled || offlineMode\" analytics-on=\"click\" analytics-event=\"CID field\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\"><div ng-messages=\"forms.bindVehicleForm.customerId.$error\"><div ng-message=\"required\">{{\'form.error.required\' | translate}}</div></div></md-input-container><md-input-container ng-if=\"customerName\"><md-card-content><label class=\"customer-label\">{{\'label.customer\' | translate}}</label><div><span class=\"customer-label\">{{customerName}}</span></div></md-card-content></md-input-container><md-input-container required=\"\" ng-if=\"!checkSystemId(\'peoplenet\') && checkDVRPairMethod(\'dsn\')\" layout-fill=\"\" class=\"inputContainerSmall\"><label>{{\'activation.dvr.form.bindVehicle.label.dsn\' | translate}}</label> <input autocomplete=\"off\" name=\"dsn\" ng-model=\"dvr.dsn\" ng-change=\"validVIN(dvr.vin);\" required=\"\" ng-disabled=\"dsnSet || offlineMode\" analytics-on=\"click\" analytics-event=\"DSN field\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\"><div ng-messages=\"forms.bindVehicleForm.dsn.$error\" ng-show=\"forms.bindVehicleForm.dsn.$error\"><div ng-message=\"required\" ng-show=\"forms.bindVehicleForm.dsn.$error.required\">{{\'form.error.required\' | translate}}</div></div></md-input-container><md-input-container required=\"\" ng-if=\"checkSystemId(\'peoplenet\') && checkDVRPairMethod(\'dsn\')\" layout-fill=\"\" class=\"inputContainerSmall\"><label>{{\'activation.dvr.form.bindVehicle.label.dsn\' | translate}}</label> <input autocomplete=\"off\" name=\"dsn\" ng-model=\"dvr.dsn\" ng-change=\"validVIN(dvr.vin);\" required=\"\" ng-disabled=\"dsnSet || offlineMode\" pattern=\"(^[1,2]\\d{6,7}|\\d{7})\" analytics-on=\"click\" analytics-event=\"DSN field\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\"><div ng-messages=\"forms.bindVehicleForm.dsn.$error\" ng-show=\"forms.bindVehicleForm.dsn.$error\"><div ng-message=\"required\" ng-show=\"forms.bindVehicleForm.dsn.$error.required\">{{\'form.error.required\' | translate}}</div><div ng-message=\"pattern\" ng-show=\"forms.bindVehicleForm.dsn.$error[\'pattern\']\">{{ (forms.bindVehicleForm.dsn.$viewValue[0] == \'1\' || forms.bindVehicleForm.dsn.$viewValue[0] === \'2\') ? \'activation.dvr.form.bindVehicle.dsn.error.minMax\' : \'activation.dvr.form.bindVehicle.dsn.error.default\' | translate}}</div></div></md-input-container><md-input-container required=\"\" layout-fill=\"\" class=\"inputContainerSmall\"><label>{{\'activation.dvr.form.bindVehicle.label.vehicleNo\' | translate}}</label> <input autocomplete=\"off\" name=\"vehicleNum\" ng-disabled=\"offlineMode\" ng-model=\"dvr.vehicleNum\" ng-change=\"dvr.vehicleNum=dvr.vehicleNum.toUpperCase();\" required=\"\" analytics-on=\"click\" analytics-event=\"Vehicle number field\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\"><div ng-messages=\"forms.bindVehicleForm.vehicleNum.$error\" ng-show=\"forms.bindVehicleForm.vehicleNum.$error\"><div ng-message=\"required\" ng-show=\"forms.bindVehicleForm.vehicleNum.$error.required\">{{\'form.error.required\' | translate}}</div></div></md-input-container><md-input-container layout-fill=\"\" class=\"inputContainerVin\" ng-required=\"checkDVRPairMethod(\'vin\')\"><label>{{\'activation.dvr.form.bindVehicle.label.vin\' | translate}}</label><div class=\"fieldButtonVin\"><input autocomplete=\"off\" name=\"vin\" ng-required=\"checkDVRPairMethod(\'vin\')\" ng-disabled=\"offlineMode || (checkDVRPairMethod(\'vin\') && dsnSet)\" ng-model=\"dvr.vin\" ng-change=\"dvr.vin=dvr.vin.toUpperCase(); validVIN(dvr.vin);\" analytics-on=\"click\" analytics-event=\"Vehicle identification number field\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\"><md-button type=\"button\" class=\"md-raised md-default md-button md-xsmall\" ng-disabled=\"offlineMode\" ng-click=\"startVinBarcodeScanner($event)\"><i class=\"fa fa-barcode\"></i></md-button></div><div ng-messages=\"forms.bindVehicleForm.vin.$error\" ng-show=\"forms.bindVehicleForm.vin.$error && checkDVRPairMethod(\'vin\')\"><div ng-message=\"required\" ng-show=\"forms.bindVehicleForm.vin.$error.required\">{{\'form.error.required\' | translate}}</div></div><div class=\"messages-cont\"><div ng-if=\"checkDVRPairMethod(\'dsn\')\" class=\"message-field\">{{\'activation.dvr.form.bindVehicle.vin.message.optional\' | translate}}</div><div ng-show=\"!form.VINValid\" class=\"message-warn\">{{\'activation.dvr.form.bindVehicle.vin.message.required\' | translate}}</div><div ng-show=\"form.VINExists\" class=\"message-warn\">{{\'activation.dvr.form.bindVehicle.vin.message.alreadtExists\' | translate}}</div></div></md-input-container><md-content ng-if=\"dvr.machineType === 1\" layout-fill=\"\" class=\"activation-channels inputContainerSmall\"><md-switch ng-change=\"confirmActiveChannel(0)\" ng-class=\"(!offlineMode ? \'md-primary\': \'md-default\')\" md-no-ink=\"\" aria-label=\"Switch No Ink\" ng-model=\"channels[0]\" analytics-on=\"click\" analytics-event=\"Forward Facing Camera switch\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" ng-disabled=\"offlineMode\">{{\'activation.dvr.camerasPreview.forwardFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 1) <i class=\"fa fa-video-camera\"></i></md-switch><md-switch ng-change=\"confirmActiveChannel(1)\" ng-class=\"(!offlineMode ? \'md-primary\': \'md-default\')\" md-no-ink=\"\" aria-label=\"Switch No Ink\" ng-model=\"channels[1]\" analytics-on=\"click\" analytics-event=\"Rear Facing Camera switch\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" ng-disabled=\"offlineMode\">{{\'activation.dvr.camerasPreview.rearFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 2)<i class=\"fa fa-video-camera\"></i></md-switch></md-content><md-content ng-if=\"dvr.machineType !== 1\" layout-fill=\"\" class=\"activation-channels inputContainerSmall\"><md-switch ng-change=\"confirmActiveChannel(0)\" ng-class=\"(!offlineMode ? \'md-primary\': \'md-default\')\" md-no-ink=\"\" aria-label=\"Switch No Ink\" ng-model=\"channels[0]\" analytics-on=\"click\" analytics-event=\"Forward Facing Camera switch\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" ng-disabled=\"offlineMode\">{{\'activation.dvr.camerasPreview.forwardFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 1) <i class=\"fa fa-video-camera\"></i></md-switch><md-switch ng-change=\"confirmActiveChannel(1)\" ng-class=\"(!offlineMode ? \'md-primary\': \'md-default\')\" md-no-ink=\"\" aria-label=\"Switch No Ink\" ng-model=\"channels[1]\" analytics-on=\"click\" analytics-event=\"Passenger Side Camera switch\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" ng-disabled=\"offlineMode\">{{dvr.machineType === 4 ? \'activation.dvr.adplus2.camerasPreview.inCabinCamera\' : \'activation.dvr.camerasPreview.passengerSideCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 2) <i class=\"fa fa-video-camera\"></i></md-switch><md-switch ng-change=\"confirmActiveChannel(2)\" ng-class=\"(!offlineMode ? \'md-primary\': \'md-default\')\" md-no-ink=\"\" aria-label=\"Switch No Ink\" ng-model=\"channels[2]\" analytics-on=\"click\" analytics-event=\"Rear Facing Camera switch\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" ng-disabled=\"offlineMode\">{{dvr.machineType === 4 ? \'activation.dvr.camerasPreview.passengerSideCamera\' : \'activation.dvr.camerasPreview.rearFacingCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 3) <i class=\"fa fa-video-camera\"></i></md-switch><md-switch ng-change=\"confirmActiveChannel(3)\" ng-class=\"(!offlineMode ? \'md-primary\': \'md-default\')\" md-no-ink=\"\" aria-label=\"Switch No Ink\" ng-model=\"channels[3]\" analytics-on=\"click\" analytics-event=\"Driver Side Camera switch\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" ng-disabled=\"offlineMode\">{{\'activation.dvr.camerasPreview.driverSideCamera\' | translate}} ({{\'label.abbr.channel\' | translate}} 4)<i class=\"fa fa-video-camera\"></i></md-switch></md-content><div class=\"alertmodal\" ng-if=\"swap.showField\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">{{\'activation.dvr.form.bindVehicle.modal.swapDvr.title\' | translate}}</span></md-card-title-text></md-card-title><md-card-content>{{\'activation.dvr.form.bindVehicle.modal.swapDvr.content.message\' | translate}}<md-input-container required=\"\" ng-show!=\"swap.showField\" layout-fill=\"\" class=\"inputContainerSmall\"><label>{{\'activation.dvr.form.bindVehicle.modal.swapDvr.label.newSerialNo\' | translate}}</label> <input autocomplete=\"off\" name=\"newSerial\" ng-model=\"swap.newSerial\"><div ng-show=\"newSerialRequired\"><div class=\"errorMessage\">{{\'form.error.required\' | translate}}</div></div></md-input-container></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ng-click=\"swap.showField = false\">{{\'label.cancel\' | translate}}</md-button></md-card-actions></md-card></div><md-button class=\"md-raised\" ng-visible=\"!offlineMode\" wz-previous=\"\" analytics-on=\"click\" analytics-event=\"Previous button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\" style=\"width:40px;\">{{\'label.prev\' | translate | uppercase}}</md-button><div ng-show=\"!offlineMode\" style=\"display:flex;\"><md-button class=\"md-raised md-success single-bt halfbt\" ng-visible=\"!offlineMode\" ng-disabled=\"!forms.bindVehicleForm.$valid && !formIsValid()\" ng-click=\"link(true, true, $event)\" ng-if=\"!dsnSet\" analytics-on=\"click\" analytics-event=\"Link button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'label.pair\' | translate | uppercase}}</md-button><md-button class=\"md-raised md-warn btnwarn\" style=\"margin-top: 0px; width: 100%\" ng-click=\"showConfirmAction($event, \'UNPAIRONLINE\', dvr)\" ng-if=\"dsnSet\" analytics-on=\"click\" analytics-event=\"Unlink button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'label.unPair\' | translate | uppercase}}</md-button></div><div ng-show=\"!offlineMode\" style=\"display:flex;\"><md-button class=\"md-raised\" style=\"margin-top: 0px; width: 100%\" ng-visible=\"!offlineMode\" ng-disabled=\"!forms.bindVehicleForm.$valid && !formIsValid()\" ng-click=\"showConfirmAction($event, \'UPDATE\', dvr)\" ng-if=\"dsnSet\" analytics-on=\"click\" analytics-event=\"Update button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'label.update\' | translate | uppercase}}</md-button></div><div ng-show=\"offlineMode\" style=\"display:flex;\"><md-button class=\"md-raised md-warn btnwarn\" style=\"margin-top: 0px; width: 100%\" ng-click=\"showConfirmAction($event, \'UNPAIROFFLINE\')\" analytics-on=\"click\" analytics-event=\"Unpair offline button\" analytics-properties=\"{category:\'Installation\', label:\'Configure Step\'}\">{{\'label.unPair\' | translate | uppercase}}</md-button></div></form></div></div><div flex=\"\"></div></div></wz-step><wz-step wz-title=\"Finish\"><div layout=\"row\"><div flex=\"\" ng-if=\"!isM1NInstall()\"></div><div flex=\"\" flex-gt-sm=\"10\" flex-gt-md=\"30\" ng-if=\"isM1NInstall()\"></div><div layout=\"column\" class=\"wizard-step-body\"><div layout=\"column\"><h4 style=\"color:green; padding-left: 10px;\">{{\'activation.dvr.pair.finish.success\' | translate}}</h4><table class=\"table table-m1n\" style=\"margin-right:auto;\"><tbody><tr><td>{{\'activation.dvr.pair.finish.label.cid\' | translate}}:</td><td>{{ dvr.customerId }}</td></tr><tr ng-if=\"customerName\"><td>{{\'label.customer\' | translate}}:</td><td>{{ customerName }}</td></tr><tr><td>{{\'activation.dvr.pair.finish.label.serialNo\' | translate}}:</td><td>{{ dvr.serialNo }}</td></tr><tr ng-if=\"checkDVRPairMethod(\'dsn\')\"><td>{{\'activation.dvr.pair.finish.label.dsn\' | translate}}:</td><td>{{ dvr.dsn }}</td></tr><tr ng-if=\"checkDVRPairMethod(\'vin\')\"><td>{{\'activation.dvr.pair.finish.label.vin\' | translate}}:</td><td>{{ dvr.vin }}</td></tr><tr><td>{{\'activation.dvr.pair.finish.label.vehicleNumber\' | translate}}:</td><td>{{ dvr.vehicleNum }}</td></tr></tbody></table><div class=\"wizard-button-panel\" ng-if=\"!isM1NInstall()\"><div layout=\"column\"><span style=\"padding-left: 10px\">{{\'activation.dvr.pair.finish.label.configureAnother\' | translate}}</span><md-button class=\"md-raised md-primary\" ng-click=\"reset(true)\">{{\'activation.dvr.pair.finish.label.searchAgain\' | translate}}</md-button></div></div><div ng-if=\"isM1NInstall() && !isAdplusInstall()\"><div layout=\"column\" class=\"margin-top-30\" style=\"padding-left: 10px;\"><b style=\"word-break: break-word;\">To complete the installation and set-up process, please proceed to the Veyes application. If you have not already done so, you can download it here:</b></div><div layout=\"column\" layout-align=\"center\" class=\"margin-top-30\" style=\"margin-right: auto\"><table style=\"padding-left: 10px;\"><tr><td style=\"text-align: center;\">iOS App</td><td style=\"text-align: center;\">Android app</td></tr><tr><td style=\"text-align: center;\"><a href=\"https://apps.apple.com/us/app/veyes/id1444251371\" target=\"_blank\"><img class=\"store-icon\" src=\"/images/apple-store.svg\"></a></td><td style=\"text-align: center;\"><a href=\"https://play.google.com/store/apps/details?id=com.streamaxtech.mdvr.smartpad\" target=\"_blank\"><img class=\"store-icon\" src=\"/images/google-store.svg\"></a></td></tr></table><div layout=\"column\" class=\"margin-top-10\" style=\"padding-left: 10px;\">After completing the steps in the application, your DVR system will be ready to use.</div></div><div layout=\"column\" class=\"margin-top-20\"><span style=\"padding-left: 10px; text-align: center;\">Configure another DVR?</span><md-button class=\"md-raised md-primary m1n-button\" ng-click=\"reset(true)\">Yes, search again!</md-button></div></div><div ng-if=\"isM1NInstall() && isAdplusInstall()\"><div layout=\"column\" class=\"margin-top-30\" style=\"padding-left: 10px;\"><b style=\"word-break: break-word;\">To complete the installation and set-up process, please proceed to the EzInstaller application. If you have not already done so, you can download it here:</b></div><div layout=\"column\" layout-align=\"center\" class=\"margin-top-30\" style=\"margin-right: auto\"><table style=\"padding-left: 10px;\"><tr><td style=\"text-align: center;\">iOS App</td><td style=\"text-align: center;\">Android app</td></tr><tr><td style=\"text-align: center;\"><a href=\"https://apps.apple.com/us/app/ezinstaller/id1576331557\" target=\"_blank\"><img class=\"store-icon\" src=\"/images/apple-store.svg\"></a></td><td style=\"text-align: center;\"><a href=\"https://play.google.com/store/apps/details?id=com.streamax.exInstaller&pcampaignid=web_share\" target=\"_blank\"><img class=\"store-icon\" src=\"/images/google-store.svg\"></a></td></tr></table><div layout=\"column\" class=\"margin-top-10\" style=\"padding-left: 10px;\">After completing the steps in the application, your DVR system will be ready to use.</div></div><div layout=\"column\" class=\"margin-top-20\"><span style=\"padding-left: 10px; text-align: center;\">Configure another DVR?</span><md-button class=\"md-raised md-primary m1n-button\" ng-click=\"reset(true)\">Yes, search again!</md-button></div></div></div></div><div flex=\"\" flex-gt-sm=\"10\" flex-gt-md=\"30\" ng-if=\"isM1NInstall()\"></div><div flex=\"\" ng-if=\"!isM1NInstall()\"></div></div></wz-step></wizard></div>");
$templateCache.put("app/auth/auth.html","<md-content layout=\"row\" layout-fill=\"\" layout-padding=\"\" layout-align=\"center center\"><md-card flex=\"25\" flex-md=\"50\" flex-sm=\"100\" class=\"login-card\"><md-toolbar class=\"toolbar\"><h2 class=\"md-toolbar-tools\">{{\'auth.dvr.login.title\' | translate}}</h2></md-toolbar><md-card-content><form name=\"loginForm\" ng-submit=\"login(credentials)\" novalidate=\"\"><md-input-container><label>{{userNameModeLabel | translate}}</label> <input ng-model=\"credentials.user\" required=\"\" name=\"user\" placeholder=\"{{userNameModeLabel | translate}}\"></md-input-container><md-input-container><label>{{\'label.password\' | translate}}</label> <input type=\"password\" ng-model=\"credentials.password\" required=\"\" name=\"password\" placeholder=\"{{\'label.password\' | translate}}\"></md-input-container><md-content layout-fill=\"\" style=\"overflow: hidden;\"><label class=\"md-caption\">{{\'label.system\' | translate}}</label><md-select id=\"systemSelect\" placeholder=\"{{systemsLoading ? \'auth.dvr.form.login.loadingSystems\' : \'label.system\' | translate}}\" ng-model=\"systemId\" layout-fill=\"\" ng-change=\"updateUserNameModeLabel()\"><md-option ng-value=\"op.value\" ng-repeat=\"op in options.systemIds\">{{\'systems.\'+op.value | translate}}</md-option></md-select></md-content><md-content layout-fill=\"\" ng-show=\"showLoginError\" class=\"errorContainer\"><label>* {{\'auth.dvr.form.login.error.incorrectPassword\' | translate}}</label></md-content><md-content ng-show=\"displayNewPolicies\" class=\"margin-top-20\"><div class=\"security-policies-title\"><i class=\"fa fa-warning\"></i><h4>{{\'auth.dvr.form.login.securityPolicy.title\' | translate}}</h4></div><label class=\"md-caption\">{{\'auth.dvr.form.login.securityPolicy.content\' | translate}}</label></md-content><div class=\"margin-top-30\"><md-button class=\"md-raised md-primary md-button\">{{\'label.login\' | translate}}</md-button></div></form></md-card-content></md-card></md-content>");
$templateCache.put("app/main/main.html","<header ng-include=\"\'app/components/navbar/navbar.html\'\"><md-sidenav class=\"md-sidenav-left\" md-component-id=\"closeEventsDisabled\" md-whiteframe=\"4\" md-disable-close-events=\"\"><md-toolbar class=\"md-theme-indigo\"><h1 class=\"md-toolbar-tools\">{{\'main.sideNav.disableEvents\' | translate}}</h1></md-toolbar><md-content layout-margin=\"\"><p>{{\'main.sideNav.backdrop.warning\' | translate}}</p><md-button ng-click=\"toggleSidenav()\" class=\"md-accent\">{{\'main.sideNav.close\' | translate}}</md-button></md-content></md-sidenav></header><section class=\"searchSection\"><div flex=\"\" layout=\"row\"><form name=\"dvrSettingsForm\"><div layout-gt-sm=\"row\" layout-sm=\"column\" flex=\"\"><md-switch ng-model=\"search.mode\" ng-if=\"search.mode !== modes.ip\" ng-true-value=\"\'dsn\'\" ng-false-value=\"\'serial\'\" class=\"md-primary\" style=\"min-width: 85px; margin-top: 10px; margin-bottom: 0px;\">{{\'main.dvr.form.settings.label.serial\' | translate}}</md-switch><md-input-container><label>{{ search.mode.toUpperCase() }}</label> <input ng-model=\"search.value\" ng-if=\"search.mode !== modes.ip\"> <input ng-model=\"search.value\" ng-pattern=\"/^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/\" ng-if=\"search.mode === modes.ip\"></md-input-container><md-content style=\"margin-top: 10px;\"><md-button class=\"md-raised md-primary md-button\" ng-click=\"getConfig()\" ng-disabled=\"!dvrSettingsForm.$valid\">{{\'label.search\' | translate}}</md-button></md-content></div></form></div><spam flex=\"\"></spam></section><md-divider></md-divider><div layout=\"row\" class=\"mainLoading\" layout-sm=\"column\" layout-align=\"space-around\" ng-show=\"showLoading\"><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></div><md-content class=\"successContainer\" layout-fill=\"\" ng-show=\"showSuccessPosting\"><label>{{\'main.dvr.update.success\' | translate}}</label></md-content><md-content class=\"errorContainer\" layout-fill=\"\" ng-show=\"showDeviceError\"><label>* {{\'main.dvr.error.offline\' | translate}}</label></md-content><md-content class=\"errorContainer\" layout-fill=\"\" ng-show=\"showEmptyDsn\"><label>* {{\'main.dvr.error.required\' | translate}}</label></md-content><div ng-show=\"(obj.dvr != null && showLoading === false)\"><md-tabs md-selected=\"tabSelected\" md-border-bottom=\"\" md-dynamic-height=\"\"><md-tab ng-disabled=\"!tabs.enabled.dvrIdentification\" label=\"Information\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-gt-sm=\"row\" layout-sm=\"column\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><div flex=\"\" layout=\"row\" ng-if=\"search.mode === modes.ip\"><md-input-container layout-padding=\"\" layout-fill=\"\"><span class=\"warn\">{{\'main.dvr.configuration.warn.link\' | translate}}</span></md-input-container></div><fieldset ng-if=\"search.mode !== modes.ip\"><div flex=\"\" layout=\"row\" ng-if=\"search.mode === modes.ip\"><md-input-container layout-padding=\"\" layout-fill=\"\"><span class=\"warn\">{{\'main.dvr.configuration.warn.remote\' | translate}}</span></md-input-container></div><div flex=\"\" layout=\"column\"><form name=\"bindVehicleForm\"><div layout-gt-sm=\"row\" layout-sm=\"column\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.form.bindVehicle.label.cid\' | translate}}</label> <input ng-maxlength=\"32\" name=\"customerId\" required=\"\" ng-model=\"tabs.obj.dvrIdentification.customerId\" pattern=\"[a-zA-Z0-9]+\" ng-disabled=\"dsnSet\"><div ng-messages=\"bindVehicleForm.customerId.$error\"><div ng-message=\"md-maxlength\">{{\'main.dvr.form.bindVehicle.error.cid\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\" ng-if=\"tabs.obj.dvrIdentification.customerName !== \'\'\"><label for=\"customerName\">{{\'label.customer\' | translate}}</label> <input name=\"customerName\" ng-model=\"tabs.obj.dvrIdentification.customerName\" ng-disabled=\"true\" title=\"{{tabs.obj.dvrIdentification.customerName}}\"></md-input-container><md-input-container layout-padding=\"\" required=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.form.bindVehicle.label.dsn\' | translate}}</label> <input name=\"dsn\" ng-model=\"tabs.obj.dvrIdentification.link.value\" required=\"\" ng-disabled=\"dsnSet\"><div ng-messages=\"bindVehicleForm.dsn.$error\"><div ng-message=\"\">{{\'main.dvr.form.bindVehicle.error.dsn\' | translate}}</div></div></md-input-container></div></form></div><md-content flex=\"\"><md-button class=\"md-raised md-warn\" ng-disabled=\"true || search.mode === modes.ip || !bindVehicleForm.$valid\" ng-click=\"link(true)\" ng-if=\"!dsnSet\">{{\'label.link\' | translate}}</md-button><md-button class=\"md-raised md-warn\" ng-disabled=\"true || search.mode === modes.ip || !bindVehicleForm.$valid\" ng-click=\"link(false)\" ng-if=\"dsnSet\">{{\'label.unLink\' | translate}}</md-button></md-content></fieldset><div flex=\"\" layout=\"column\"><form name=\"informationForm\"><div layout=\"row\"><fieldset class=\"standard\" ng-if=\"search.mode !== modes.ip\" layout-fill=\"\" style=\"margin-top:10px; margin-left:1px;\"><legend>{{\'main.dvr.form.info.label.trigger\' | translate}}</legend><div layout=\"column\" layout-wrap=\"\" layout-gt-sm=\"row\"><md-radio-group ng-model=\"tabs.obj.dvrIdentification.triggerType\" style=\"display:inline-flex\"><md-radio-button ng-repeat=\"item in options.triggerTypes\" class=\"md-primary\" ng-value=\"item.value\">{{ item.text | translate}}</md-radio-button></md-radio-group></div></fieldset></div><md-divider style=\"margin-top:20px; margin-bottom:20px;\"></md-divider><div layout-gt-sm=\"row\" layout-sm=\"column\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.form.info.label.vehicleNo\' | translate}}</label> <input md-maxlength=\"128\" name=\"vehicleNum\" required=\"\" ng-model=\"tabs.obj.dvrIdentification.vehicleNum\"><div ng-messages=\"informationForm.vehicleNum.$error\"><div ng-message=\"md-maxlength\">{{\'main.dvr.form.info.error.vehicleNo\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.form.info.label.serialNo\' | translate}}</label> <input md-maxlength=\"60\" name=\"serialNo\" ng-model=\"tabs.obj.dvrIdentification.serialNo\" ng-disabled=\"serialNumberSet\"><div ng-messages=\"informationForm.serialNo.$error\"><div ng-message=\"md-maxlength\">{{\'main.dvr.form.info.error.serialNo\' | translate}}</div></div></md-input-container></div></form></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!informationForm.$valid\" ng-click=\"postData(\'dvrIdentification\', tabs.json.dvrIdentification)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrIdentification}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrVideoChannelConfig\" label=\"Video Channel\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><div ng-repeat=\"item in tabs.obj.dvrVideoChannelConfig\" flex=\"\" layout=\"column\"><h4>{{\'label.channel\' | translate}} {{item.channelId}}</h4><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.VBR\' | translate}}</label><md-select placeholder=\"{{main.dvr.label.VBR | translate}}\" ng-model=\"item.bitrate\"><md-option ng-value=\"op\" ng-repeat=\"op in options.bitrate\">{{op}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.CFR\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.label.CFR\' | translate}}\" ng-model=\"item.framerate\"><md-option ng-value=\"op\" ng-repeat=\"op in options.framerate\">{{op}}</md-option></md-select></md-content></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.CR\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.label.CR\' | translate}}\" ng-model=\"item.resolution\"><md-option ng-value=\"op.value\" ng-repeat=\"op in options.resolution\">{{op.name}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.CAE\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.label.CAE\' | translate}}\" ng-model=\"item.audioEnabled\"><md-option ng-value=\"op\" ng-repeat=\"op in options.audioEnabled\">{{op}}</md-option></md-select></md-content></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.OSDE\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.placeholder.OSDE\' | translate}}\" ng-model=\"item.OSDEnabled\"><md-option ng-value=\"op\" ng-repeat=\"op in options.osdEnabled\">{{op}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.OSDM\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.placeholder.OSDM\' | translate}}\" ng-model=\"item.OSDMirrored\"><md-option ng-value=\"op\" ng-repeat=\"op in options.osdMirrored\">{{op}}</md-option></md-select></md-content></div><md-divider class=\"divider\"></md-divider></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"jsonError\" ng-click=\"postData(\'videoChannelConfig\', tabs.json.dvrVideoChannelConfig)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrVideoChannelConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrRecordingSettings\" label=\"Recording\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-gt-sm=\"row\" layout-sm=\"column\"><div flex=\"\"><div flex=\"\" layout=\"column\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><form name=\"recordingForm\"><div layout=\"column\" class=\"inputTextRow\" layout-padding=\"\"><md-content layout-padding=\"\" class=\"inputSelectContainer\"><label class=\"md-caption\">{{\'main.dvr.label.LFM\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.ph.LFM\' | translate}}\" ng-model=\"tabs.obj.dvrRecordingSettings.loopFileMinutes\"><md-option ng-value=\"op\" ng-repeat=\"op in options.loopFileMinutes\">{{op}}</md-option></md-select></md-content><div layout-sm=\"column\" layout-gt-sm=\"row\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\" flex=\"50\"><label>{{\'main.dvr.label.EBP\'| translate}}</label> <input max=\"99\" min=\"1\" pattern=\"\\d+\" name=\"eventBufferPct\" type=\"number\" ng-model=\"tabs.obj.dvrRecordingSettings.eventBufferPct\" required=\"\"><div ng-messages=\"recordingForm.eventBufferPct.$error\"><div ng-message=\"\">{{\'main.dvr.EBP.error\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\" flex=\"50\"><label>{{\'main.dvr.label.CLWL\' | translate}}</label> <input min=\"501\" max=\"999\" pattern=\"\\d+\" name=\"continueLoopWaterLevel\" type=\"number\" ng-model=\"tabs.obj.dvrRecordingSettings.continueLoopWaterLevel\" required=\"\"><div ng-messages=\"recordingForm.continueLoopWaterLevel.$error\"><div ng-message=\"\">{{\'main.dvr.CLWL.error\' | translate}}</div></div></md-input-container></div></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 1 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 1\" ng-model=\"tabs.obj.dvrRecordingSettings.recEnableArray[0]\"><md-option ng-value=\"op.value\" ng-repeat=\"op in options.recordChannelEnabled\">{{op.name}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 2 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 2\" ng-model=\"tabs.obj.dvrRecordingSettings.recEnableArray[1]\"><md-option ng-value=\"op.value\" ng-repeat=\"op in options.recordChannelEnabled\">{{op.name}}</md-option></md-select></md-content></div><div layout-sm=\"column\" ng-if=\"tabs.obj.dvrIdentification.machineType !== 1\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 3 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 3\" ng-model=\"tabs.obj.dvrRecordingSettings.recEnableArray[2]\"><md-option ng-value=\"op.value\" ng-repeat=\"op in options.recordChannelEnabled\">{{op.name}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 4 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 4\" ng-model=\"tabs.obj.dvrRecordingSettings.recEnableArray[3]\"><md-option ng-value=\"op.value\" ng-repeat=\"op in options.recordChannelEnabled\">{{op.name}}</md-option></md-select></md-content></div></form><md-divider class=\"divider\"></md-divider></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!recordingForm.$valid\" ng-click=\"postData(\'recordingSettings\', tabs.json.dvrRecordingSettings)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrRecordingSettings}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrTimeConfig\" label=\"Time\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-gt-sm=\"row\" layout-sm=\"column\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><div flex=\"\" layout=\"column\"><form name=\"timeForm\"><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.NTPS\' | translate}}</label> <input name=\"ntpServer\" type=\"text\" ng-model=\"tabs.obj.dvrTimeConfig.ntpServer\" required=\"\"><div ng-messages=\"timeForm.ntpServer.$error\"><div ng-message=\"\">{{\'main.dvr.NTPS.error\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.NTPRI\' | translate}}</label> <input min=\"1\" required=\"\" pattern=\"\\d+\" name=\"ntpIntervalMinutes\" type=\"number\" ng-model=\"tabs.obj.dvrTimeConfig.ntpIntervalMinutes\"><div ng-messages=\"timeForm.ntpIntervalMinutes.$error\"><div ng-message=\"\">{{\'main.dvr.NTPRI.error\' | translate}}</div></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.GSB\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.ph.GSB\' | translate}}\" ng-model=\"tabs.obj.dvrTimeConfig.gpsSyncBackup\"><md-option ng-value=\"op\" ng-repeat=\"op in options.gpsSyncBackup\">{{op}}</md-option></md-select></md-content></div></form><md-divider class=\"divider\"></md-divider></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!timeForm.$valid\" ng-click=\"postData(\'timeConfig\', tabs.json.dvrTimeConfig)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrTimeConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrTimeConfig\" label=\"Media Delivery\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-gt-sm=\"row\" layout-sm=\"column\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><div flex=\"\" layout=\"column\"><form name=\"mediaDeliveryForm\"><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.url\' | translate}}</label> <input name=\"url\" type=\"text\" ng-model=\"tabs.obj.dvrMediaDeliveryConfig.url\" required=\"\"><div ng-messages=\"timeForm.url.$error\"><div ng-message=\"\"></div></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.accessKey\' | translate}}</label> <input name=\"accesskey\" ng-model=\"tabs.obj.dvrMediaDeliveryConfig.accessKey\" required=\"\"><div ng-messages=\"timeForm.accesskey.$error\"><div ng-message=\"\"></div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.secretKey\' | translate}}</label> <input name=\"secretkey\" ng-model=\"tabs.obj.dvrMediaDeliveryConfig.secretKey\" required=\"\"><div ng-messages=\"timeForm.secretkey.$error\"><div ng-message=\"\"></div></div></md-input-container></div></form><md-divider class=\"divider\"></md-divider></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!mediaDeliveryForm.$valid\" ng-click=\"postData(\'mediaDeliveryConfig\', tabs.json.dvrMediaDeliveryConfig)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrMediaDeliveryConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrManagement\" label=\"Management Server\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-gt-sm=\"row\" layout-sm=\"column\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><div flex=\"\" layout=\"column\"><form name=\"managementServerForm\"><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.url\' | translate}}</label> <input name=\"url\" type=\"text\" ng-model=\"tabs.obj.dvrManagementServerConfig.url\" required=\"\"><div ng-messages=\"managementServerForm.url.$error\"><div ng-message=\"t\">{{\'main.dvr.url.error\' | translate}}</div></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'label.user\' | translate}}</label> <input name=\"user\" ng-model=\"tabs.obj.dvrManagementServerConfig.user\" required=\"\"><div ng-messages=\"managementServerForm.user.$error\"><div ng-message=\"\"></div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'label.password\' | translate}}</label> <input name=\"password\" ng-model=\"tabs.obj.dvrManagementServerConfig.password\" required=\"\"><div ng-messages=\"managementServerForm.password.$error\"><div ng-message=\"\"></div></div></md-input-container></div></form><md-divider class=\"divider\"></md-divider></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!managementServerForm.$valid\" ng-click=\"postData(\'managementServerConfig\', tabs.json.dvrManagementServerConfig, true)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrManagementServerConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrNetworkConfig\" label=\"Network\"><md-divider></md-divider><div layout-padding=\"\"><div layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-gt-sm=\"row\" layout-sm=\"column\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><div flex=\"\" layout=\"column\"><form name=\"networkForm\"><h4>{{\'main.dvr.label.ethernet\' | translate}}</h4><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\" layout-padding=\"\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.ip\' | translate}}</label> <input name=\"ipAddress\" type=\"text\" ng-model=\"tabs.obj.dvrNetworkConfig.ethernet.ipAddress\" required=\"\"><div ng-messages=\"networkForm.ip.$error\"><div ng-message=\"\">{{\'main.dvr.ip.error\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.submask\' | translate}}</label> <input name=\"subnetMask\" type=\"text\" ng-model=\"tabs.obj.dvrNetworkConfig.ethernet.subnetMask\" required=\"\"><div ng-messages=\"networkForm.subnetMask.$error\"><div ng-message=\"\">{{\'main.dvr.submask.error\' | translate}}</div></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\" layout-padding=\"\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.dns\' | translate}}</label> <input name=\"dnsServer\" type=\"text\" ng-model=\"tabs.obj.dvrNetworkConfig.ethernet.dnsServer\" required=\"\"><div ng-messages=\"networkForm.dnsServer.$error\"><div ng-message=\"\">{{\'main.dvr.dns.error\' | translate}}</div></div></md-input-container></div><md-divider class=\"divider\"></md-divider><h4>{{\'main.dvr.label.wifi\' | translate}}</h4><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content layout-padding=\"\" class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.wifiEn\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.label.wifiEn\' | translate}}\" ng-model=\"tabs.obj.dvrNetworkConfig.wifi.enable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.wifiEnable\">{{op}}</md-option></md-select></md-content><md-content layout-padding=\"\" class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.wifiSec\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.label.wifiSec\' | translate}}\" ng-model=\"tabs.obj.dvrNetworkConfig.wifi.encryption\"><md-option ng-value=\"op\" ng-repeat=\"op in options.wifiSecurity\">{{op}}</md-option></md-select></md-content></div><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\" layout-padding=\"\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.wifiSSID\' | translate}}</label> <input name=\"ssid\" type=\"text\" ng-model=\"tabs.obj.dvrNetworkConfig.wifi.ssid\" ng-maxlength=\"15\" required=\"\"><div ng-messages=\"networkForm.dvrNetworkConfig.$error\"><div ng-message=\"\">{{\'main.dvr.wifiSSID.error\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.wifiPwd\' | translate}}</label> <input name=\"wifiPassword\" ng-model=\"tabs.obj.dvrNetworkConfig.wifi.password\" required=\"\"><div ng-messages=\"networkForm.wifiPassword.$error\"><div ng-message=\"\"></div></div></md-input-container></div><md-divider class=\"divider\"></md-divider><h4>{{\'main.dvr.label.cellular\' | translate}}</h4><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\" layout-padding=\"\"><md-content layout-padding=\"\" class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.celrEn\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.label.celrEn\' | translate}}\" ng-model=\"tabs.obj.dvrNetworkConfig.cellular.enabled\"><md-option ng-value=\"op\" ng-repeat=\"op in options.celullarEnabled\">{{op}}</md-option></md-select></md-content></div><div layout-sm=\"column\" layout-gt-sm=\"row\" class=\"inputTextRow\" layout-padding=\"\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.celrAPN\' | translate}}</label> <input name=\"ssid\" type=\"text\" ng-model=\"tabs.obj.dvrNetworkConfig.cellular.apn\" required=\"\"><div ng-messages=\"networkForm.apn.$error\"><div ng-message=\"\"></div></div></md-input-container></div></form><md-divider class=\"divider\"></md-divider></div><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!networkForm.$valid\" ng-click=\"postData(\'networkConfig\', tabs.json.dvrNetworkConfig, true)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrNetworkConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrEventConfig\" label=\"Event\"><md-divider></md-divider><div layout-padding=\"\"><div layout=\"vertical\" layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\" layout-fill=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><form name=\"eventForm\"><div layout-gt-sm=\"row\" layout-sm=\"column\" class=\"inputTextRow\" layout-padding=\"\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.PreSec\' | translate}}</label> <input min=\"1\" max=\"899\" name=\"preSeconds\" ng-model=\"tabs.obj.dvrEventConfig.preSeconds\" pattern=\"\\d+\" type=\"number\" required=\"\"><div ng-messages=\"eventForm.preSeconds.$error\"><div ng-message=\"md-maxlength\">{{\'main.dvr.PreSec.error\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.PostSec\' | translate}}</label> <input min=\"1\" max=\"899\" name=\"postSeconds\" ng-model=\"tabs.obj.dvrEventConfig.postSeconds\" pattern=\"\\d+\" type=\"number\" required=\"\"><div ng-messages=\"eventForm.postSeconds.$error\"><div ng-message=\"md-maxlength\">{{\'main.dvr.PostSec.error\' | translate}}</div></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 1 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 1\" ng-model=\"tabs.obj.dvrEventConfig.channel1Enable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.channedEnabled\">{{op}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 2 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 2\" ng-model=\"tabs.obj.dvrEventConfig.channel2Enable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.channedEnabled\">{{op}}</md-option></md-select></md-content></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 3 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 3\" ng-model=\"tabs.obj.dvrEventConfig.channel3Enable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.channedEnabled\">{{op}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.channel\' | translate}} 4 {{\'label.enabled\' | translate}}</label><md-select placeholder=\"{{\'label.channel\' | translate}} 4\" ng-model=\"tabs.obj.dvrEventConfig.channel4Enable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.channedEnabled\">{{op}}</md-option></md-select></md-content></div></form><md-divider class=\"divider\"></md-divider><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!eventForm.$valid\" ng-click=\"postData(\'eventConfig\', tabs.json.dvrEventConfig)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.dvrEventConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrAccConfig\" label=\"ACC Config\"><md-divider></md-divider><div layout-padding=\"\"><div layout=\"vertical\" layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\" layout-fill=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><form name=\"accForm\"><div layout-gt-sm=\"row\" layout-sm=\"column\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.SD\' | translate}}</label> <input min=\"0\" name=\"delay\" ng-model=\"tabs.obj.accConfig.delaySec\" pattern=\"\\d+\" type=\"number\" required=\"\" max=\"43200\"><div ng-messages=\"accForm.delay.$error\"><div ng-message=\"md-maxlength\">{{\'main.dvr.SD.error\' | translate}}</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.POV\' | translate}}</label> <input min=\"0\" name=\"poweroffVoltage\" ng-model=\"tabs.obj.accConfig.poweroffVoltage\" pattern=\"\\d+\" type=\"number\" required=\"\"><div ng-messages=\"accForm.poweroffVoltage.$error\"><div ng-message=\"\">{{\'main.dvr.POV.error\' | translate}}</div></div></md-input-container></div></form><md-divider class=\"divider\"></md-divider><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!accForm.$valid\" ng-click=\"postData(\'accConfig\', tabs.json.accConfig)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.accConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrLogging\" label=\"Logging\"><md-divider></md-divider><div layout-padding=\"\"><div layout=\"vertical\" layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\" layout-fill=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><form name=\"logConfigForm\"><div layout-gt-sm=\"row\" layout-sm=\"column\" class=\"inputTextRow\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.RL\' | translate}}</label> <input min=\"0\" name=\"recLevel\" ng-model=\"tabs.obj.logConfig.recLevel\" pattern=\"\\d+\" type=\"number\" required=\"\"><div ng-messages=\"logConfigForm.recLevel.$error\"><div ng-message=\"\">({{\'label.default\' | translate}}: 2)</div></div></md-input-container><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.UL\' | translate}}</label> <input min=\"0\" name=\"poweroffVoltage\" ng-model=\"tabs.obj.logConfig.uploadLevel\" pattern=\"\\d+\" type=\"number\" required=\"\"><div ng-messages=\"logConfigForm.uploadLevel.$error\"><div ng-message=\"\">({{\'label.default\' | translate}}: 0)</div></div></md-input-container></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.GPSLogEn\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.ph.GPSLogEn\' | translate}}\" ng-model=\"tabs.obj.logConfig.gpsLog\"><md-option ng-value=\"op\" ng-repeat=\"op in options.gpsLog\">{{op}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.GSEn\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.ph.GSEn\' | translate}}\" ng-model=\"tabs.obj.logConfig.gsensorLog\"><md-option ng-value=\"op\" ng-repeat=\"op in options.gsensorLog\">{{op}}</md-option></md-select></md-content></div><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-padding=\"\"><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.tcpDnE\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.ph.tcpDEn\' | translate}}\" ng-model=\"tabs.obj.logConfig.tcpDumpEnable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.tcpDumpEnable\">{{op}}</md-option></md-select></md-content><md-content class=\"inputSelectContainer\" flex=\"\"><label class=\"md-caption\">{{\'main.dvr.label.kmdEn\' | translate}}</label><md-select placeholder=\"{{\'main.dvr.ph.kmdEn\' | translate}}\" ng-model=\"tabs.obj.logConfig.kmsgDumpEnable\"><md-option ng-value=\"op\" ng-repeat=\"op in options.kmsgDumpEnable\">{{op}}</md-option></md-select></md-content></div></form><md-divider class=\"divider\"></md-divider><md-content class=\"md-padding\" flex=\"\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!logConfigForm.$valid\" ng-click=\"postData(\'logConfig\', tabs.json.logConfig)\">{{\'label.save\' | translate}}</md-button></md-content></div><div flex=\"\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.logConfig}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrSetup\" label=\"Summary\"><md-divider></md-divider><div layout-padding=\"\"><div layout=\"vertical\" layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><md-content layout-padding=\"\" flex=\"\" ng-if=\"!isNodeWebkit()\"><md-button href=\"\" download=\"config.json\" content=\"Download\" trigger=\"focus\" ng-disabled=\"json.dvr == null\" ng-click=\"downloadConfiguration($event, json.dvr)\" class=\"md-raised md-primary\"><i class=\"fa fa-download\"></i> {{\'label.download\' | translate}}</md-button></md-content><md-content layout-padding=\"\" flex=\"\" ng-show=\"getMode() === \'remote\'\"><md-button content=\"Save\" trigger=\"focus\" ng-disabled=\"json.dvr == null\" ng-show=\"!showSaveConfiguration\" ng-click=\"showSaveConfigurationPanel()\" class=\"md-raised\">{{\'label.save\' | translate}}</md-button></md-content><div ng-show=\"showSaveConfiguration\" layout-padding=\"\"><fieldset><legend>{{\'main.dvr.label.saveConfig\' | translate}}</legend><form name=\"saveConfigPreview\"><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\" layout-fill=\"\"><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-fill=\"\" flex=\"\"><md-content class=\"inputSelectContainer\" flex=\"\" style=\"margin-top:6px;\"><label class=\"md-caption\">{{\'label.customer\' | translate}}</label><md-select ng-model=\"configuration.customer\" placeholder=\"{{\'label.customer\' | translate}}\" style=\"min-width: 200px; width:100%;\" flex=\"\"><md-option value=\"0\">{{\'label.default\' | translate}}</md-option><md-option ng-repeat=\"cust in customerList\" value=\"{{ {value: cust.value, id: cust.id} }}\">{{cust.value + \' (\' + cust.id + \')\'}}</md-option></md-select></md-content><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\" flex=\"\"><label>{{\'main.dvr.label.configName\' | translate}}</label> <input name=\"configName\" ng-model=\"configuration.name\" required=\"\"></md-input-container></div></div></div></form><md-button content=\"Save\" trigger=\"focus\" ng-disabled=\"json.dvr == null || !saveConfigPreview.$valid\" ng-click=\"saveConfiguration(json.dvr)\" class=\"md-raised md-primary\" layout-margin=\"\">{{\'label.save\' | translate}}</md-button><md-button content=\"Cancel\" trigger=\"focus\" ng-click=\"showSaveConfigurationPanel()\" class=\"md-raised md-primary\" layout-margin=\"\">{{\'label.cancel\' | translate}}</md-button></fieldset></div><md-divider></md-divider><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{json.dvr}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></section></md-content></div></div></md-tab><md-tab ng-disabled=\"!tabs.enabled.dvrAdvanced\" label=\"Advanced\"><md-divider></md-divider><div layout-padding=\"\"><div layout=\"vertical\" layout-fill=\"\"><md-content layout-margin=\"\" layout-fill=\"\"><section><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\" layout\"column\"=\"\"><h2>{{\'main.dvr.configuration.title\' | translate}}</h2><md-divider class=\"md-default-theme\"></md-divider><fieldset><legend>{{\'main.dvr.label.sdCard\' | translate}}</legend><div flex=\"\"><md-button content=\"Save\" trigger=\"focus\" ng-click=\"formatSd()\" class=\"md-raised md-primary\" layout-margin=\"\">{{\'main.dvr.label.formatSdCard\' | translate}}</md-button></div></fieldset><fieldset ng-show=\"getMode() === \'remote\'\"><legend>{{\'main.dvr.label.firmware\' | translate}}</legend><div flex=\"\" layout-sm=\"column\" layout-gt-sm=\"row\"><form name=\"firmwareForm\" flex=\"70\"><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\"><label>{{\'main.dvr.label.firmwareUrl\' | translate}}</label> <input min=\"0\" name=\"firmwareUrl\" ng-model=\"tabs.obj.advanced.firmwareUrl\" type=\"url\" required=\"\"><div ng-messages=\"firmwareForm.firmwareUrl.$error\"><div ng-message=\"\">{{\'main.dvr.firmwareUrl.error\' | translate}}</div></div></md-input-container></form><md-content style=\"padding-top: 26px;\"><md-button content=\"Upload Firmware\" ng-disabled=\"!firmwareForm.$valid\" trigger=\"focus\" ng-click=\"uploadFirmware(tabs.obj.advanced.firmwareUrl)\" class=\"md-raised md-primary\">{{\'main.dvr.label.uploadFirmware\' | translate}}</md-button></md-content></div></fieldset><fieldset><legend>{{\'label.configuration\' | translate}}</legend><div ng-show=\"(predefinedCustomerNamesList == null || predefinedCustomerNamesList.length == 0)\"><div flex=\"\" layout-padding=\"\" style=\"margin-bottom: 20px;\"><span>{{\'main.dvr.label.config.error\' | translate}}</span></div></div><div ng-show=\"predefinedCustomerNamesList.length > 0\" style=\"margin-top:10px; margin-botton: 10px;\"><div flex=\"\"><span>{{\'main.dvr.label.preConfig\' | translate}}</span> <span class=\"md-caption\">({{\'main.dvr.label.updatedAt\' | translate}}: {{ updatedDate }})</span></div><div flex=\"\" layout-sm=\"column\" layout-gt-sm=\"row\"><md-content flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.customers\' | translate}}</label><select style=\"width:100%\" multiple=\"true\" size=\"4\" ng-options=\"item.name for item in predefinedCustomerNamesList\" ng-model=\"customerNameSelected\" ng-change=\"changeCustomerList()\"></select></md-content><md-content flex=\"\" layout-padding=\"\"><label class=\"md-caption\">{{\'label.configurations\' | translate}}</label><select style=\"width:100%\" multiple=\"true\" size=\"4\" ng-options=\"item.display for item in customerNameSelected[0].files\" ng-model=\"configSelected\" ng-change=\"loadConfigPreview(customerNameSelected, configSelected)\"></select></md-content></div></div><div flex=\"\" layout-padding=\"\"><label style=\"margin-right: 20px;\">{{\'main.dvr.label.uploadConfig\' | translate}}:</label> <input id=\"configUpload\" type=\"file\" onchange=\"angular.element(this).scope().loadFile(this)\"></div><div flex=\"\" layout-padding=\"\"><md-checkbox ng-model=\"uploadConfig.check\" aria-label=\"{{\'main.dvr.label.validateConfig\' | translate}}\">{{\'main.dvr.label.validateConfig\' | translate}}</md-checkbox></div><div flex=\"\" layout-padding=\"\" ng-show=\"getMode() === \'remote\'\"><md-button content=\"Save Preview\" trigger=\"focus\" ng-show=\"!showSaveConfiguration\" ng-click=\"showSaveConfigurationPanel()\" class=\"md-raised md-primary\" ng-disabled=\"tabs.obj.preview == null\">{{\'main.dvr.label.savePreview\' | translate}}</md-button></div><div ng-show=\"showSaveConfiguration\" layout-padding=\"\"><fieldset><legend>{{\'main.dvr.label.saveConfig\' | translate}}</legend><form name=\"saveConfigPreview\"><div layout-sm=\"column\" layout-gt-sm=\"row\"><div flex=\"\" layout-fill=\"\"><div layout-sm=\"column\" layout-gt-sm=\"row\" layout-fill=\"\" flex=\"\"><md-content class=\"inputSelectContainer\" flex=\"\" style=\"margin-top:6px;\"><label class=\"md-caption\">{{\'label.customer\' | translate}}</label><md-select ng-model=\"configuration.customer\" placeholder=\"{{\'label.customer\' | translate}}\" style=\"min-width: 200px; width:100%;\" flex=\"\"><md-option value=\"0\">{{\'label.default\' | translate}}</md-option><md-option ng-repeat=\"cust in customerList\" value=\"{{ {value: cust.value, id: cust.id} }}\">{{cust.value + \' (\' + cust.id + \')\'}}</md-option></md-select></md-content><md-input-container layout-padding=\"\" layout-fill=\"\" class=\"inputTextContainer\" flex=\"\"><label>{{\'main.dvr.label.configName\' | translate}}</label> <input md-maxlength=\"30\" name=\"configName\" ng-model=\"configuration.name\" required=\"\"></md-input-container></div></div></div></form><md-button content=\"Save\" trigger=\"focus\" ng-disabled=\"json.dvr == null || !saveConfigPreview.$valid\" ng-click=\"saveConfiguration(tabs.json.preview)\" class=\"md-raised md-primary\" layout-margin=\"\">{{\'label.save\' | translate}}</md-button><md-button content=\"Cancel\" trigger=\"focus\" ng-click=\"showSaveConfigurationPanel()\" class=\"md-raised md-primary\" layout-margin=\"\">{{\'label.cancel\' | translate}}</md-button></fieldset></div></fieldset></div><div flex=\"\" layout-padding=\"\"><div ng-show=\"tabs.obj.preview\"><md-content layout-padding=\"\" layout=\"column\"><md-card><md-toolbar md-theme=\"altTheme\"><h2 class=\"md-toolbar-tools\">{{\'label.jsonPreview\' | translate}}</h2><div class=\"bt-titlebar\" md-theme=\"default\"><md-button class=\"md-raised md-primary\" ng-disabled=\"!tabs.obj.preview\" ng-click=\"postData(\'\', tabs.json.preview, true)\">{{\'main.dvr.label.applyPreview\' | translate}}</md-button></div></md-toolbar><md-card-content><md-input-container flex=\"\" layout-padding=\"\"><pre>\n													{{tabs.json.preview}}\n												</pre></md-input-container><md-content><label ng-show=\"jsonError\" class=\"error\">* {{jsonError}}</label></md-content></md-card-content></md-card></md-content></div></div></div></section></md-content></div></div></md-tab></md-tabs></div>");
$templateCache.put("app/components/barCodeScanner/dialog.html","<div class=\"md-dialog-container barcode-dialog-container\"><md-dialog class=\"barcode-fullscreen-dialog\"><md-button type=\"button\" class=\"md-fab md-mini button-close\" ng-click=\"closeDialog()\"><i class=\"fa fa-close\"></i></md-button><md-button type=\"button\" class=\"md-fab button-flashlight ng-hide\" ng-show=\"state.flashlight.available\" ng-class=\"{\'active\': state.flashlight.on}\" ng-click=\"toggleFlashLight($event)\"><i class=\"fa fa-lightbulb-o\"></i></md-button><md-dialog-content><div id=\"barcodeVideoContainer\" class=\"barcode-video-container\"><div class=\"barcode-overlay-top\"></div><div class=\"barcode-overlay-bottom\"></div></div></md-dialog-content></md-dialog></div>");
$templateCache.put("app/components/navbar/navbar.html","<div ng-controller=\"MenuCtrl\" layout=\"column\"><md-toolbar layout=\"row\" layout-fill=\"\" layout-padding=\"\" class=\"toolbar headerbar\"><div class=\"md-toolbar-tools flex\"><md-button class=\"md-icon-button\" ng-click=\"toggleMenu()\" ng-hide=\"isMenuOpen()\"><md-icon md-svg-icon=\"../../images/menu-icon.svg\"></md-icon></md-button><div class=\"flex title-container\"><h2>{{\'nav.toolBar.title\' | translate}}</h2><div class=\"customer-info\" ng-if=\"customerDetails.customerId\"><span class=\"customer-id\">({{customerDetails.customerId}})</span> <span class=\"customer-name\" title=\"{{customerDetails.customerName}}\" style=\"-webkit-box-orient: vertical\">&nbsp;{{customerDetails.customerName}}</span></div></div></div></md-toolbar><section layout=\"row\" flex=\"\"><md-sidenav class=\"md-sidenav-left md-whiteframe-z2\" md-component-id=\"menu\"><md-toolbar class=\"toolbar\"><h2 class=\"md-toolbar-tools\">{{\'nav.toolBar.title\' | translate}}</h2></md-toolbar><md-list><md-list-item><i class=\"fa fa-check\"></i> <a href=\"https://vi-training.s3.amazonaws.com/toolkit/index.html#/?_k=qvj096\" target=\"_blank\">{{\'nav.menu.dvrPairingGuide\' | translate}}</a></md-list-item><md-list-item><i class=\"fa fa-question-circle\"></i> <a href=\"https://sites.google.com/peoplenetonline.com/video-intelligence-resources/\" target=\"_blank\">{{\'nav.menu.trainingAndSupport\' | translate}}</a></md-list-item><md-list-item class=\"language-select-container\"><i class=\"fa fa-language\"></i><md-select id=\"systemSelect\" ng-model=\"model.selectedLocale\" layout-fill=\"\" ng-change=\"changeLocale(model.selectedLocale)\"><md-option ng-value=\"value\" ng-repeat=\"(value, key) in availableLocales\">{{key | translate}}</md-option></md-select></md-list-item><md-list-item ng-click=\"logout()\"><i class=\"fa fa-lock\"></i>{{\'nav.menu.logout\' | translate}}</md-list-item></md-list></md-sidenav></section></div>");}]);